<template>
  <div>
    <sub-menu-call-center ativo="confirmacao" v-if="!cc && !block_menu" />

    <!-- Filtros -->

    <div class="card dashcard mb-0">
      <div class="card-body">

        <div class="form-row">
          <div class="col col-12 col-md-2">
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <button type="button" class="btn btn-outline-primary" @click="load()" :disabled="$store.state.loading" id="refresh-button">
                  <i class="fas fa-sync-alt fa-fw"></i>
                </button>
              </div>
              <div class="input-group-prepend" v-if="1 == 0">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fas fa-greater-than-equal fa-fw"></i>
                </span>
              </div>
              <input type="date" class="form form-control" :disabled="pIdBloq" v-model="referencia" @change="ativar_rebuscar('I')" />
            </div>
          </div>
          <div class="col col-12 col-md-2" v-if="!cc">
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fas fa-less-than-equal fa-fw"></i>
                </span>
              </div>
              <input type="date" class="form form-control" :disabled="pIdBloq" v-model="referencia_fim" @change="ativar_rebuscar()" />
            </div>
          </div>
          <div class="col col-12" :class="cc ? 'col-md-4' : 'col-md-2'" v-if="$store.state.unidade.unidade_operacaos.length > 1">
            <az-input
              type="select"
              icon="fa fa-building fa-fw"
              placeholder="Unidades..."
              :optionsList="lista_unidades"
              optionsData="id_unidade_operacao"
              :edicao="!pIdBloq"
              v-model="refUnidOper"
              @input="load()" />
          </div>
          <div class="col col-12" :class="( $store.state.unidade.unidade_operacaos.length > 1 || !cc ) ? 'col-md-3' : 'col-md-5'">
            <az-input 
              placeholder="Especialidades..."
              icon="fas fa-filter" 
              type="select" 
              optionsMode="esp-ativas"
              optionsName="esp-ativas"
              v-model="especialidade" 
              :edicao="!pIdBloq"
              @change="load(true, 'E')" />
          </div>
          <div class="col col-12" :class="$store.state.unidade.unidade_operacaos.length > 1 ? 'col-md-3' : 'col-md-5'">

            <template v-if="filtro_lista_medicos && filtro_lista_medicos.length">
              <az-input
                type="label"
                icon="fas fa-user-md fa-fw"
                placeholder="Lista Selecionada"
                label="Lista Selecionada"
                value="Lista Selecionada">
                <template v-slot:buttonposb>
                  <div class="input-group-append" v-if="!medico">
                    <span class="input-group-text" id="basic-addon2" v-if="filtro_lista_medicos && filtro_lista_medicos.length">
                      {{ filtro_lista_medicos.length }}
                    </span>
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Selecionar Profissionais" @click="selecionar_medicos()">
                      <i class="fa-solid fa-list-check"></i>
                    </button>
                  </div>
                </template>
              </az-input>
            </template>

            <template v-else>
              <az-input
                type="select"
                icon="fas fa-user-md fa-fw"
                placeholder="Todos os Médicos..."
                :optionsList="lista_medicos"
                optionsData="id_pessoa"
                :edicao="!pIdBloq && !block_medico_fixo"
                v-model="medico"
                @input="load(true, 'M')">
                <template v-slot:buttonposb>
                  <div class="input-group-append" v-if="!medico">
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Selecionar Profissionais" @click="selecionar_medicos()">
                      <i class="fa-solid fa-list-check"></i>
                    </button>
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" data-toggle="tooltip" data-placement="top" title="Agrupar/Desagrupar por Profissionais"
                        @click="grupoProf == 'A' ? grupoProf = 'G' : grupoProf = 'A'">
                        <i class="fas fa-object-group fa-fw" v-if="grupoProf == 'A'"></i>
                        <i class="fas fa-object-ungroup fa-fw" v-else></i>
                    </button>
                  </div>
                  <div class="input-group-append" v-else-if="viewonly">
                    <div class="input-group-text" id="basic-addon2">
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div class="input-group-append" v-else>
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Observação" @click="abrir_obs(medico, referencia)">
                      <i class="fa fa-comment" aria-hidden="true"></i>
                    </button>
                  </div>
                </template>
              </az-input>
            </template>

            <!--
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fas fa-user-md fa-fw"></i>
                </span>
              </div>
              <select class="form form-control" :disabled="pIdBloq" v-model="medico" @change="load(true, 'M')">
                <option value>Todos os Médicos...</option>
                <option
                  :value="item.id_pessoa"
                  v-for="(item, index) in lista_medicos"
                  :key="index"
                >{{ item.st_nome_exibicao }}</option>
              </select>
            </div>
            -->
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col col-12 col-md-2">
            <az-input 
              type="select"
              icon="fas fa-check-double"
              placeholder="Todos..."
              optionsMode="json"
              :optionsList="[
                { id: '3', search: 'A Confirmar' },
                { id: '2', search: 'Confirmado' },
                { id: '1', search: 'Sem Retorno' },
              ]"
              optionsData="id"
              @input="load(true, 'S')"
              :edicao="!pIdBloq"
              v-model="status_confirmacao" />
          </div>
          <div class="col col-12 col-md-4">
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fas fa-search fa-fw" :class="search ? 'text-success' : ''" v-if="!search || !$store.state.loading"></i>
                  <div class="spinner-grow spinner-grow-sm" role="status" v-else>
                    <span class="sr-only">Loading...</span>
                  </div>
                </span>
              </div>
              <input
                type="text"
                class="form form-control"
                v-model="search"
                placeholder="Pesquisar..." />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ turno }}</button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" :class="turno == 'G' ? 'active' : ''" href="#" @click.prevent="turno = 'G'">Geral</a>
                  <a class="dropdown-item" :class="turno == 'M' ? 'active' : ''" href="#" @click.prevent="turno = 'M'">Turno Matutino</a>
                  <a class="dropdown-item" :class="turno == 'V' ? 'active' : ''" href="#" @click.prevent="turno = 'V'">Turno Vespertino</a>
                  <a class="dropdown-item" :class="turno == 'N' ? 'active' : ''" href="#" @click.prevent="turno = 'N'">Turno Noturno</a>
                </div>
              </div>
              <div class="input-group-append" v-if="status != 'H'">
                <button type="button" class="btn btn-outline-primary" title="Adicionar Filtros." @click="incluir_filtro()">
                    <i class="fa-solid fa-filter"></i>
                    <span class="badge badge-primary ml-1" v-if="lista_add_filtros && lista_add_filtros.length">
                        {{ lista_add_filtros.length }}
                    </span>
                </button>
              </div>
              <div class="input-group-append">
                  <relatorios-linkados 
                    pagina="confirmacao"
                    :parms="{ 
                        marcacao_id: lista_ids,
                    }" />

                    
                </div>
            </div>
          </div>
          <div class="col col-12 col-md-6">
            <az-input 
                placeholder="Selecionar paciente..."
                icon="fas fa-user"
                type="autocomplete" 
                optionsMode="aql"
                service="pacientes.index"
                optionsDisplay="search"
                ref="info_paciente"
                v-model="paciente" 
                :optimized_ac="true">
                <template v-slot:buttonposb>
                    <div class="input-group-append" v-if="paciente">
                        <button type="button" class="btn btn-outline-primary" v-if="paciente.id_pessoa > 0" 
                            @click="$root.perfil(paciente)" title="Paciente">
                            <i class="fa-solid fa-id-badge"></i>
                        </button>

                        <button type="button" class="btn btn-outline-secondary" v-if="paciente.id_pessoa < 0" 
                            @click="$root.perfil_temp(paciente)" title="Paciente">
                            <i class="fa-solid fa-id-badge"></i>
                        </button>
                    </div>
                </template>
            </az-input>
          </div>
        </div>

        <!-- Opções -->
        <div class="form-row mt-2" v-if="!$store.state.user.id_plano">
          <div class="col col-12 col-md-4" v-if="filas_proc && filas_proc.length">
            <az-input
              icon="fas fa-bars fa-fw"
              type="select"
              sizing="sm"
              placeholder="Filtro pela fila de procedimento..."
              :optionsList="filas_proc"
              optionsData="id_fila_laudo"
              optionsDisplay="search"
              :edicao="this.status != 'H'"
              v-model="id_fila_laudo">
            </az-input>
          </div>
          <div class="col col-12" :class="( filas_proc && filas_proc.length ) ? 'col-md-8' : ''">
            <az-input
              sizing="sm"
              :edicao="!pIdBloq"
              type="button-group"
              :optionsList="lista_status"
              optionsData="id"
              v-model="status" 
              @input="load()" />
          </div>
        </div>

        <div class="form-row mt-2" v-if="status == 'H' && $store.state.user.id_usuario == 1">
          <div class="col col-12 col-md-6">
            <az-input
              sizing="sm"
              placeholder="Operadora/Plano..."
              icon="far fa-credit-card"
              type="autocomplete"
              optionsMode="aql"
              optionsName="planos.atendimento"
              :optionsParm="{
                  atendimento: true,
                  plano_id_unidade_operacao: refUnidOper
              }"
              service="planos.index"
              :optionsSync="false"
              v-model="dados.plano"
              ref="info_plano"
              input2="selecionarPlano(dados.plano)"
              onEnter2="focusOn('info_procedimento')" />
          </div>
          <div class="col col-12 col-md-6">
            <az-input
              sizing="sm"
              placeholder="Selecione o Procedimento..."
              icon="fas fa-play"
              :edicao="dados.plano ? true : false"
              type="autocomplete"
              optionsMode="aql"
              :optionsName="( $store.state.user.proc_oper ? 'procedimentos.agenda.op.' + ( dados.plano.id_operadora == 1 ? 'p.' + dados.plano.id_plano : dados.plano.id_operadora ) : 'procedimentos.agenda' ) 
                  + ( cc ? '.cc' : '' ) + ( infusao ? '.infusao' : '' ) "
              :optionsParm="$store.state.user.proc_oper 
                  ? { 
                      id_operadora: dados.plano.id_operadora, 
                      id_plano: dados.plano.id_plano, 
                      id_unidade_operacao: refUnidOper,
                      cc: cc, 
                      infusao: infusao, 
                  } 
                  : {
                      id_unidade_operacao: refUnidOper, 
                      cc: cc,
                      infusao: infusao, 
                  }"
              :optionsSync="false"
              v-model="dados.procedimento"
              ref="info_procedimento"
              @input="selecionarProcedimento (dados.procedimento)"
              onEnter2="enterNoProcedimento ()">
              <template v-slot:buttonposb>
                <div class="input-group-append" v-if="dados.procedimento">
                  <button type="button" class="btn btn-outline-danger" @click="dados.procedimento = ''">
                    <i class="fa-solid fa-eraser"></i>
                  </button>
                </div>
              </template>
            </az-input>

            <div v-if="dados && dados.procedimento && dados.procedimento.fl_recurso">
              <selecao-recursos v-model="dados.procedimento_equipamentos" :equipamentos="recursos" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="progress mt-1 mb-3">
        <div class="indeterminate" v-if="$store.state.loading && lista && lista.length"></div>
        <div class="determinate" v-else></div>
    </div>

    <template v-if="agenda_do_medico">
      <agenda-do-medico :dados="agenda_do_medico" :referencia="referencia" @trocar="trocar_data" />
    </template>

    <medico-obs-lista :medico_obs="medico_obs" @refresh="load(false)" />

    <p class="alert alert-warning" v-if="pIdBloq">Consulta de Agenda Bloqueada</p>

    <div class="form-row" v-if="lista_locais && lista_locais.length">
        <div class="col col-12 col-md-6">
            <az-input 
                sizing="sm"
                type="select"
                icon="fas fa-map-marker-alt fa-fw"
                placeholder="Selecione o local..."
                :optionsList="lista_locais"
                optionsData="id_local"
                v-model="filtro_id_local" />
        </div>
    </div>

    <!-- Mapa de Sala -->
    <mapa-de-sala 
      ref="mapa" 
      v-show="( hor_livre_todos || this.filtro_lista_medicos.length ) && status == 'H' && show_mapa" 
      :simplificado="true" 
      @selecionado="selecionar_medico_dia" />

    <!-- Empty State -->
    <div class="mt-3" v-if="( !show_mapa || info_md ) && ( !lista || !lista.length || !agrupar (lista_por_turno, 'data') )">
      <az-empty-state
        :feriado="feriado"
        :bloqueio="bloqueio"
        :msg="lista === null 
              ? 'Clique aqui para buscar.'
              : ( search || especialidade ) ? 'Nenhum paciente encontrado.' : 'Nenhum paciente marcado para essa data.'"
        :icon="lista === null ? 'fas fa-sync-alt' : ( search ? 'fas fa-search' : 'fas fa-user-clock' )"
        :action="lista === null ? 'Buscar' : ''"
        :method="load"></az-empty-state>
    </div>

    <div ref="tabagd" v-else-if="!show_mapa || info_md">

      <div v-if="info_md">
        {{ $util.getFormatDate(info_md.data) }}
      </div>

      <template v-if="( hor_livre_todos || this.filtro_lista_medicos.length ) && status == 'H'"> <!-- " && ( !medico || this.referencia != this.referencia_fim || ( show_medico_agenda_recursos && marcacoes_recursos ) )"> -->

        <div class="form-row mt-1">
          <div class="col col-12" :class="show_medico_agenda_recursos ? 'col-md-6' : 'col-md-12'">
            <az-input 
              type="checkbox-group"
              label="Exibir agenda em tabela."
              v-model="show_medico_agenda_recursos"
              @click="toggle_exibir_tabela()">
              <template v-slot:buttonposcb>
                <div class="input-group-append">
                    <print-export printid="lista_tabela" :left="!show_medico_agenda_recursos">
                        <template v-slot:dropdownitem>
                            <div class="dropdown-divider "></div>
                            <a class="dropdown-item" href="#" @click="imprimirAgendas(referencia)">
                                <i class="fa-solid fa-print fa-fw mr-2"></i>
                                Imprimir Lista
                            </a>
                        </template>
                    </print-export>
                </div>
              </template>
            </az-input>
          </div>

          <div class="col col-12 col-md-6" v-if="show_medico_agenda_recursos">
            <az-input 
              type="checkbox-group"
              label="Exibir apenas horários livres."
              v-model="show_apenas_livres" />
          </div>
        </div>

      </template>

      <template v-if="show_medico_agenda_recursos && ( hor_livre_todos || this.filtro_lista_medicos.length ) && status == 'H'"> <!-- && ( !medico || this.referencia != this.referencia_fim || ( show_medico_agenda_recursos && marcacoes_recursos ) ) -->

        <div id="lista_tabela">

            <!-- && ( !medico || this.referencia != this.referencia_fim || ( show_medico_agenda_recursos && marcacoes_recursos ) ) -->

            <tabela-agendas 
                :confirm="true"
                v-if="( hor_livre_todos || this.filtro_lista_medicos.length ) && status == 'H'" 
                :apenas_livres="show_apenas_livres"
                :agendas="lista_por_turno" 
                :marcacoes_recursos="this.referencia != this.referencia_fim ? [] : marcacoes_recursos"
                :cc="cc" 
                :callback="editar_marcacao"
                :pode_bloquear_horario="pode_bloquear_horario"
                @bloquearhorario="bloquear_horario"
                @ver_autorizacao="ver_autorizacao"
                @ver_arquivos="abrir_anexar_arquivo"
                @refresh="load(false)"
                :medico="medico" />

        </div>

      </template>

      <!-- Lista de Marcações Realizadas -->

      <template v-else>

        <div class="mt-3" v-for="(dia, idia) in agrupar (lista_por_turno, 'data')" :key="idia">
            <p class="alert alert-primary" v-if="referencia != referencia_fim">
            <span class="lead mr-1">{{ $util.getFormatDate(idia) }},</span>
            <span class="text-muted">{{ $util.getFormatDate(idia, 'dddd') }}</span>
            </p>

            <div class="mt-3" :id="'listCall' + idia">
            <!-- Cabecalho ao Imprimir -->
            <div v-if="!show_print" class="d-flex flex-column">
                <div class="mx-auto font-weight">Lista de Confirmação</div>
                <div class="d-flex flex-column">
                <div class="d-flex flex-row">
                    Data: {{ $util.getFormatDate(idia) }} <!-- referencia -->
                    <div v-if="medico">Medico:{{medico}}</div>
                </div>
                <div class="d-flex flex-row">
                    <div v-if="search">Filtro de Busca: {{search}}</div>
                    <div v-if="status">Status: {{exibicaoStatus}}</div>
                </div>
                </div>
            </div>

            <div v-for="(quebra, iq,index) in agrupar (dia)" :key="index">
                <div class="mt-3 mb-1 d-flex justify-content-between" v-if="iq != ' Lista '">
                    <h5 class="mb-0">
                        {{ iq }}
                        <span class="badge badge-secondary" v-if="paginacao && paginacao.last_page > 1">
                            {{ paginacao.from }} - 
                            {{ paginacao.to }} / 
                            {{ paginacao.total }}
                        </span>
                        <template v-else-if="qtd_status(quebra, 'livre')">
                            <span class="badge badge-success ml-1" v-if="qtd_status(quebra, 'ocupado', true) != qtd_status(quebra, 'ocupado')" title="Marcações">
                                {{ qtd_status(quebra, 'ocupado') }}
                            </span>
                            <span class="badge badge-secondary ml-1" title="Ocupados vs Livres">
                                {{ qtd_status(quebra, 'ocupado', true) }} / {{ qtd_status(quebra, 'livre') }}
                            </span>
                        </template>
                        <template v-else>
                            <span class="badge badge-dark ml-1" title="Total">
                                {{ quebra.length }}
                            </span>
                        </template>
                    </h5>

                    <div v-if="!viewonly">
                        <button
                            class="btn btn-outline-secondary ml-2"
                            title="Marcar pacientes atendidos para nova data."
                            @click="marcar_bloco(quebra)"
                            v-if="pode_marcar_bloco && show_print && index==0"> <!-- && status == 'H' -->
                            <i class="fa-regular fa-calendar-plus"></i>
                        </button>

                        <button
                            class="btn btn-outline-secondary ml-2"
                            data-toggle="tooltip" data-placement="top" title="Enviar Mensagens de Confirmação"
                            @click="enviar_lista_confirmacao(quebra)"
                            :disabled="enviada_confirmacao"
                            v-if="enviar_confirmacao && show_print && ( iq == 'A Confirmar' || !paginacao )">
                            <i class="fas fa-share"></i>
                        </button>

                        <button
                            class="btn btn-outline-secondary ml-2"
                            data-toggle="tooltip" data-placement="top" title="Imprimir Lista"
                            @click="imprimirAgendas(idia)" 
                            v-if="show_print && index==0">
                            <i class="fas fa-print"></i>
                        </button>
                        <!-- imprimirLista('listCall' + idia) -->

                        <button
                            class="btn btn-outline-secondary ml-2"
                            title="Trocar Médico Auxiliar"
                            @click="trocar_medico_comp(quebra, false, true)"
                            v-if="medico && show_print && confirm_medico_residente">
                            <i class="fa-solid fa-user-doctor"></i>
                        </button>

                        <button
                            class="btn btn-outline-secondary ml-2"
                            title="Trocar Médico da Agenda Compartilhada"
                            @click="trocar_medico_comp(quebra)"
                            v-else-if="medico && show_print && ( tem_medico_comp(quebra) )">
                            <i class="fa-solid fa-user-doctor"></i>
                        </button>

                        <button
                            class="btn btn-outline-primary ml-2"
                            data-toggle="tooltip" data-placement="top" title="Alterar Profissional"
                            @click="trocar_medico_comp(quebra, false)"
                            v-else-if="show_print && medico && confirm_trocar_medico">
                            <i class="fa-solid fa-user-doctor"></i>
                        </button>

                        <button
                            class="btn btn-outline-primary ml-2"
                            data-toggle="tooltip" data-placement="top" title="Adicionar Marcação"
                            @click="novoAtendimento()"
                            v-if="show_print && index==0 && status == 'H'">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>

                <!--
                <draggable ghost-class="primary"
                :class="index == drag_to_idx && drag_to_idx !== null ? 'drag-to' : ''" 
                draggable=".marcacao-arrastavel" 
                @drop='onDrop($event, hor)' 
                @dragenter.prevent="!hor.marcacao ? drag_to_idx = index : ''" 
                @dragover.prevent="!hor.marcacao ? drag_to_idx = index : ''"
                @dragleave="drag_to_idx = null"
                @dragend="drag_to_idx = null">
                -->

                <div class="card mb-2 dashcard" class2="w3-animate-opacity carde" v-for="(hor, index) in ordem_hor(quebra)" :key="index">
                    <div class="card-body p-1 px-2">
                        <div class="row">
                            <!-- Ação -->
                            <div class="col col-12 col-md-2 d-flex flex-column justify-content-center">
                            <div v-if="hor && hor.marcacao && hor.status == 'agendado'">
                                {{ hor.marcacao.status_confirmacao }}
                            </div>

                            <template v-if="!hor.marcacao && hor.status == 'bloqueado'">
                                <div class="btn-group btn-sm" role="group" aria-label="Basic example" v-if="pode_bloquear_horario && hor.bloqueio && hor.bloqueio.id_agenda">
                                    <button type="button" class="btn btn-danger btn-sm" disabled>
                                        Bloqueado
                                    </button>
                                    <button type="button" class="btn btn-outline-danger btn-sm ml-1" title="Liberar horário" 
                                        v-if="!viewonly"
                                        @click="bloquear_horario(hor)"
                                        :disabled="$store.state.loading">
                                        <i class="far fa-circle"></i>
                                    </button>  
                                </div>  

                                <button type="button" class="btn btn-danger btn-sm mx-1" disabled v-else>
                                    Bloqueado
                                </button>
                            </template>

                            <template v-else-if="!hor.marcacao && hor.status == 'indisponivel'">
                                <button type="button" class="btn btn-outline-secondary btn-sm mx-1" disabled>
                                Indisponível
                                </button>
                            </template>

                            <div class="btn-group btn-sm" role="group" aria-label="Basic example" v-else-if="!hor.marcacao && referencia >= $util.hoje()">
                                <template v-if="hor.status == 'reservado'">
                                    <button type="button" class="btn btn-outline-danger btn-sm" @click="verMarcar(hor)" :disabled="$store.state.loading" v-if="!viewonly">
                                        Reservado
                                    </button>
                                    <button type="button" class="btn btn-outline-danger btn-sm ml-1" title="Remover Reserva" 
                                        @click="remover_reserva(hor)" :disabled="$store.state.loading || hor.status != 'reservado'" v-if="!viewonly && pode_bloquear_horario && !hor.ordem_chegada">
                                        <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                    </button>
                                </template>

                                <template v-else>
                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="verMarcar(hor)" :disabled="$store.state.loading || hor.status == 'passado'" v-if="!viewonly">
                                        <span v-if="hor.status == 'enviando...'">
                                            <div class="spinner-border spinner-border-sm mr-2" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            {{ hor.status }}
                                        </span>
                                        <span v-else>
                                            Agendar
                                        </span>
                                    </button>
                                    <button type="button" class="btn btn-outline-danger btn-sm ml-1" title="Bloquear horário" 
                                        @click="bloquear_horario(hor)" :disabled="$store.state.loading || hor.status == 'passado'" 
                                        v-if="!viewonly && pode_bloquear_horario && !hor.ordem_chegada">
                                        <i class="fa fa-ban fa-fw" aria-hidden="true"></i>
                                    </button>
                                </template>
                            </div>

                            <!-- Faltoso -->
                            <div class="my-1 text-center text-md-left"
                                v-if="hor.marcacao && hor.marcacao.item_status && ( hor.marcacao.item_status.valor == 'faltoso' || hor.marcacao.item_status.valor == 'bloqueado' ) && show_print==true ">

                                <i :class="hor.marcacao && hor.marcacao.item_status.icon" class="mr-2"></i>
                                <a href="#" @click.prevent='( search == "\"faltoso\"" ? search = "" : search = "\"faltoso\"" ); pesquisar();' class="card-link">
                                    <span class="mr-2">{{ hor.marcacao.item_status.valor }}</span>
                                </a>
                                <div>
                                    <confirmacao-botoes ref="conf_falta" :iq="iq" :hor="hor" v-if="!viewonly" />
                                </div>
                            </div>

                            <!-- Opções -->
                            <div class="my-1 text-center text-md-left"
                                v-else-if="hor.marcacao && hor.marcacao.item_status && ( hor.marcacao.item_status.valor == 'agendado' )  && show_print==true ">
                                
                                <confirmacao-botoes ref="conf_btn" :iq="iq" :hor="hor" v-if="!viewonly"/>
                            </div>

                            <div
                                v-else-if="hor.marcacao && hor.marcacao.item_status && hor.marcacao.item_status.valor == 'agendado' && show_print == false && 1 == 0"
                                class="m-1 text-center text-md-left">
                                <i class="fas fa-times mr-2"></i>não confirmado
                            </div>

                            <div class="m-1 text-center text-md-left" v-else-if="hor.marcacao && hor.marcacao.item_status && hor.marcacao.item_status.valor != 'agendado'">
                                <i :class="hor.marcacao && hor.marcacao.item_status.icon" class="mr-2"></i>
                                <span :class="'text-' + hor.marcacao.item_status.color">
                                    <a href="#" @click.prevent='( search == "\"" + hor.marcacao.item_status.valor + "\"" 
                                        ? search = "" : search = "\"" + hor.marcacao.item_status.valor + "\"" ); pesquisar();' class="card-link">
                                        {{ hor.marcacao.item_status.valor }}
                                    </a>
                                </span>
                                <div>
                                    <button type="button" class="btn btn-outline-warning btn-sm mr-1 mb-1"
                                        data-toggle2="tooltip" data-placement="top" title="Remarcar" @click="remarcar(hor.marcacao)"
                                        v-if="hor.marcacao.local && hor.marcacao.local.fl_coleta_dom && hor.data >= $util.hoje()">
                                        <i class="fas fa-retweet"></i>
                                    </button>
                                    <button type="button" class="btn btn-outline-primary btn-sm mr-1 mb-1"
                                        data-toggle2="tooltip" data-placement="top" title="Adicionar marcação" @click="adcionar_marcacao(hor.marcacao)"
                                        v-if="!viewonly && ( iq != 'Confirmada' )">
                                        <i class="fa-regular fa-calendar-plus"></i>
                                    </button>

                                    <span class="dropdown" v-if="hor.marcacao && hor.marcacao.dt_inicio.slice(0,10) > $util.hoje() && !viewonly">
                                        <button class="btn btn-sm btn-outline-secondary dropdown-toggle mb-1 mr-1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-phone"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a class="dropdown-item" href="#" @click="confirmar (hor.marcacao, 'C')">
                                                <i class="fas fa-phone fa-fw text-success mr-2"></i>
                                                Confirmar
                                            </a>

                                            <a class="dropdown-item" href="#" @click="confirmar (hor.marcacao, 'S')">
                                                <i class="fas fa-phone-slash fa-fw mr-2"></i>
                                                Sem Resposta
                                            </a>
                                        </div>
                                    </span>

                                    <span class="ml-2 small" v-if="hor.marcacao.id_atendimento">
                                        <a href="#" @click.prevent="abrir_atendimento(hor.marcacao.id_atendimento)" class="card-link">
                                            #{{ hor.marcacao.id_atendimento }}
                                        </a>
                                    </span>
                                    <span class="ml-2 small text-muted" v-if="false">{{ hor.marcacao.st_id_externo }}</span>
                                </div>
                            </div>
                            </div>

                            <!-- Hora da Marcação -->
                            <!-- 
                                
                            -->

                            <template v-if="status == 'H' && hor.marcacao && hor.marcacao.item_status && hor.marcacao.item_status.valor == 'agendado' && !$store.state.loading">
                            <div class="col col-12 col-md-2">
                                <div class="d-flex justify-content-center justify-content-md-start">
                                <celula-horarios-marcacao :hor="hor" :showPrint="show_print" @pesquisar="set_nome_search">
                                    <span v-if="status == 'H' && hor.marcacao && hor.marcacao.item_status.valor == 'agendado'"
                                    :draggable="status == 'H' && hor.marcacao && hor.marcacao.item_status.valor == 'agendado' && !$store.state.loading" 
                                    @dragstart='startDrag($event, hor)' 
                                    :class="( status == 'H' && hor.marcacao && hor.marcacao.item_status.valor == 'agendado' && !$store.state.loading ) ? 'marcacao-arrastavel' : ''">
                                    <i class="fas fa-bars mr-2"></i>
                                    </span>
                                </celula-horarios-marcacao>
                                </div>
                                <div class="small text-muted" v-if="hor.marcacao && hor.bloqs">
                                <i class="fa fa-ban mr-2" aria-hidden="true"></i>
                                {{ hor.bloqs }}
                                </div>
                            </div>
                            
                            </template>

                            <template v-else>
                            <div class="col col-12 col-md-2">
                                <div class="d-flex flex-column" v-if="hor.marcacao && hor.marcacao.autorizacao">
                                    <a href="#" @click.prevent="ver_autorizacao (hor.marcacao)" class="badge" :class="'badge-' + hor.marcacao.autorizacao.status_solicitacao.color">
                                        {{ hor.marcacao.autorizacao.status_solicitacao.msg }}
                                    </a>
                                </div>
                                <div class="d-flex justify-content-center justify-content-md-start">
                                    <celula-horarios-marcacao :hor="hor" :showPrint="show_print" @pesquisar="set_nome_search" />
                                </div>
                            </div>
                            </template>

                            <!-- Identificação do Paciente -->
                            <div class="col col-12 col-md-3" v-if="hor.marcacao ">
                                <celula-dados-paciente 
                                    :hor="hor" 
                                    :showPrint="show_print" 
                                    :callback_paciente="set_nome_search" 
                                    :anexos="true"
                                    @abriranexos="abrir_anexar_arquivo" />
                                </div>

                                <!-- Contatos do Paciente -->
                                <div class="col col-12 col-md-2" v-if="hor.marcacao">
                                <celula-dados-contatos :hor="hor" />
                            </div>

                            <!-- Identificação do Procedimento -->
                            <div class="col col-12 col-md-3 d-flex justify-content-between" v-if="hor.marcacao">
                                <celula-dados-procedimento :hor="hor" :showPrint="show_print" @abriranexos="abrir_anexar_arquivo" />

                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2" v-if="!viewonly && hor.status != 'livre' && hor.marcacao.ch_estado_marcacao != 'C'">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <template v-if="hor.marcacao">
                                        <button class="dropdown-item" @click="novoDocumento(hor.marcacao)">Emitir Documento</button>
                                        <button class="dropdown-item" @click="cadastrar_paciente(hor.marcacao)" v-if="!hor.marcacao.id_paciente">Cadastrar Paciente</button>
                                        <button class="dropdown-item" @click="alterar_extra(hor.marcacao)" v-if="pode_alterar_extra && hor.marcacao.fl_extra && !hor.marcacao.id_atendimento && hor.marcacao.dt_inicio.slice(0,10) >= $util.hoje()">Alterar Data/Hora do Atendimento</button>
                                        <button class="dropdown-item" @click="abrir_log_int(hor.marcacao)" v-if="hor.marcacao && ( $store.state.user.id_usuario == 1 || is_teste )">Log de Integração (Marcação)</button>

                                        <button
                                            v-if="$store.state.user.tem_adiantamentos && hor.marcacao && hor.marcacao.plano && hor.marcacao.plano.id_operadora == 1"
                                            class="dropdown-item" @click="abrir_pagamentos(hor.marcacao)">
                                            Pagamentos
                                        </button>

                                        <div class="dropdown-divider"></div>

                                        <button class="dropdown-item" @click="solicitar_estoque(hor.marcacao)">Solicitar Material para Consumo</button>
                                    </template>
                                    </div>
                                </div>
                            </div>

                            <div class="col col-12 col-md-8" v-if="!hor.marcacao && hor.status == 'bloqueado'">
                                <span v-if="pode_bloquear_horario && hor.bloqueio && hor.bloqueio.id_agenda">
                                    <a href="#" @click.prevent="set_obs_bloqueio(hor)" class="card-link">
                                        <span v-if="hor.bloqueio.st_observacao">{{ hor.bloqueio.st_observacao }}</span>
                                        <span class="small" v-else>Observação...</span>
                                    </a>
                                </span>
                                <span v-else-if="hor.bloqueio.st_observacao">{{ hor.bloqueio.st_observacao }}</span>

                                <div v-if="hor.bloqueio.usuario" class="small text-muted">
                                    Por: {{ hor.bloqueio.usuario.st_login }} 
                                    <span v-if="hor.bloqueio.dt_bloqueio">| {{ $util.getFormatDate(hor.bloqueio.dt_bloqueio) }} {{ hor.bloqueio.dt_bloqueio.slice(11,16) }}</span>
                                </div>
                            </div>

                            <div class="col col-12 col-md-8" v-if="!hor.marcacao && hor.status == 'reservado'">
                                <div v-if="hor.reserva && hor.reserva.paciente">
                                    Reservado para: {{ hor.reserva.paciente.st_nome }}
                                </div>
                                <div v-else-if="hor.reserva && hor.reserva.cadastro_temporario">
                                    Reservado para: {{ hor.reserva.cadastro_temporario.st_nome }}
                                </div>
                                <div v-if="hor.reserva && hor.reserva.st_obs">
                                    {{ hor.reserva.st_obs }}
                                </div>
                                <div v-if="hor.reserva && hor.reserva.usuario" class="small text-muted">
                                    Reservado por: {{ hor.reserva.usuario.st_login }} 
                                    | {{ $util.getFormatDate(hor.reserva.created_at) }} {{ hor.reserva.created_at.slice(11,16) }}
                                    | Até {{ $util.getFormatDate(hor.reserva.dt_limite_reserva) }} {{ hor.reserva.dt_limite_reserva.slice(11,16) }}
                                </div>
                            </div>

                            <div class="col col-12 col-md-8" v-else-if="!hor.marcacao && hor.agenda_procedimentos && hor.agenda_procedimentos.length <= 5">
                                <a href="#" @click.prevent="verMarcar(hor, proc)" v-for="(proc, iex) in hor.agenda_procedimentos" :key="iex">
                                    <span class="badge mr-1" :class="proc.bloqueado ? 'badge-danger' : 'badge-primary'"
                                    :title="proc.st_procedimento">
                                    {{ proc.st_sigla ? proc.st_sigla : proc.st_procedimento }}
                                    <i class="fas fa-registered text-warning" v-if="proc.tipo_consulta == 'R'"></i>
                                    <i class="fas fa-copyright text-dark" v-if="proc.tipo_consulta == 'C'"></i>
                                    </span>
                                </a>

                                <div v-if="hor.medico_comp" class="small text-muted">
                                    {{ hor.medico_comp.st_nome_exibicao }}
                                </div>

                                <div v-if="hor.bloqueio && hor.bloqueio.st_observacao" class="small text-muted" :title="'#' +  hor.bloqueio.id_bloqueio">{{ hor.bloqueio.st_observacao }}</div>
                            </div>

                            <div class="col col-12 col-md-8">
                                <div class="small text-muted" v-if="hor.medico_comp">
                                    {{ hor.medico_comp.st_nome_exibicao }}
                                </div>

                                <div v-if="hor.bloqueio && hor.bloqueio.st_observacao" class="small text-muted" :title="'#' +  hor.bloqueio.id_bloqueio">{{ hor.bloqueio.st_observacao }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-0" v-if="hor.marcacao && hor.marcacao.paciente && hor.marcacao.paciente.atendimento_pacotes && hor.marcacao.paciente.atendimento_pacotes.length">
                        <historico-pacotes-paciente 
                            autoriz2="true"
                            :id_procedimento="hor.marcacao.id_procedimento"
                            :lista="hor.marcacao.paciente.atendimento_pacotes" 
                            :ativos="true"
                            :reduzido="true" />
                    </div>
                </div>
                
                <!-- </draggable> -->

            </div>
            </div>
        </div>
      </template>

      <button type="button" class="btn btn-sm btn-outline-primary mt-3" v-if="$store.state.user.id_usuario == 1 && tem_tk" @click="integrar_klingo_pacientes()" :disabled="$store.state.loading">
        Integrar Pacientes
      </button>

      <button type="button" class="btn btn-sm btn-outline-primary mt-3" v-else-if="reintegracao_labs" @click="reintegrar_pacientes()" :disabled="$store.state.loading">
        Reintegrar Pacientes
      </button>

    </div>

    <!-- Cancelar Marcação -->
    <cancelar-marcacao ref="canc_atd" @cancelado="load(false)" />

    <!-- Confirmação de Marcação -->
    <div
      class="modal fade"
      id="confirmacaoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLabel"
            >{{ confirm_tipo == 'C' ? 'Confirmar Marcação' : 'Sem Resposta' }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <template v-if="confirm_marcacao">
              <div class="row">
                <div class="col col-12 col-md-6">
                  <div class="row">
                    <div class="col col-12">
                      <h4
                        v-if="confirm_marcacao && confirm_marcacao.paciente"
                      >{{ confirm_marcacao.paciente.st_nome }}</h4>

                      <h4
                        v-else-if="confirm_marcacao && confirm_marcacao.cadastro_temporario"
                      >{{ confirm_marcacao.cadastro_temporario.st_nome }}</h4>

                      <az-input label="Observação" type="textarea" v-model="confirm_obs" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col col-12">
                      <ul class="list-group mt-2">
                        <li
                          class="list-group-item"
                          v-for="(hist, ih) in confirm_marcacao.historico_status_marcacaos"
                          :key="ih"
                        >
                          <div>
                            {{ $util.getFormatDate(hist.dt_mudanca_status) }}
                            {{ hist.dt_mudanca_status.substr(11,5) }}
                            <span class="text-muted" v-if="hist.usuario">por {{ hist.usuario.st_login }}</span>
                            <span class="badge badge-secondary ml-2">{{ hist.status_marcacao.st_status }}</span>
                          </div>
                          <div>
                            <small class="text-muted">{{ hist.st_observacao }}</small>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col col-12 col-md-6">
                  <template v-if="outras_ordenadas && outras_ordenadas.length">
                    <procedimentos-solicitados :key="componentKey" :listOnly="marcacao_unica()" v-model="outras_ordenadas" />
                  </template>

                  <div class="mt-3">
                    <az-instrucoes ref="instruc_conf" />
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer" v-if="confirm_marcacao">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit
              :color="confirm_tipo == 'C' ? 'success' : 'danger'"
              @click="confirmar_salvar()"
            >{{ confirm_tipo == 'C' ? 'Confirmar' : 'Sem Resposta' }}</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Marcação -->
    <div class="modal fade" id="novoAtendimentoConfirmacaoModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog2 modal-dialog-scrollable" role="document" v-if="flag_agendar">
        <div class="modal-content modal-content2">
          <div class="modal-header">
            <span>Agendar</span>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="fechar_modal('novoAtendimentoConfirmacaoModal')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <marcacao
                ref="marcacao"
                :data="ref_marcar"
                :hora="refHora"
                :hg="refHg"
                :id_unidade_operacao="marcar_id_unidade_operacao"
                modalName="novoAtendimentoConfirmacaoModal"
                @refresh="load(false)"
                origem="confirm"
              />
          </div>
        </div>
      </div>
    </div>

    <!-- Envio de Arquivo -->
    <template v-if="acao_anexar">
      <az-file-upload
        ref="upload"
        :multiple="true"
        @refresh="carregar_arquivos()"
        :arquivos="marcacao.arquivos"
        :parms="{ 
          model_type: marcacao.id_marcacao 
            ? 'marcacao' : ( marcacao.id_cadastro_temporario ? 'cadastroTemporario' : 'pessoa' ), 
          model_id: marcacao.id_marcacao 
            ? marcacao.id_marcacao : ( marcacao.id_cadastro_temporario ? marcacao.id_cadastro_temporario : marcacao.id_pessoa ), 
          id_paciente: marcacao.id_paciente ? marcacao.id_paciente : marcacao.id_pessoa,
          tipo_especial: marcacao.id_marcacao ? null : 'anexo', 
        }"
        parms2="{ model_type: 'marcacao', model_id: marcacao.id_marcacao }" />
    </template>

    <template v-if="instrucoes">
      <div class="card dashcard mt-3" v-for="(inst, idx) in instrucoes" :key="idx">
        <div class="card-header">
          <div>Instruções para {{ inst.title }}</div>
        </div>
        <div class="card-body d-flex justify-content-between">
          <div>
            <span v-html="inst.text"></span>
          </div>
          <a :href="agenda_do_medico.foto" target="_blank" v-if="agenda_do_medico">
            <avatar 
              :username="agenda_do_medico.nome" 
              :src="agenda_do_medico.foto"
              :size="80"></avatar>
          </a>
        </div>
      </div>
    </template>

    <br><br><br>

    <!-- Paginação -->
    <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="paginacao && paginacao.last_page > 1">
      <div class="d-flex">
        <paginate
            class="mb-0"
            :page-count="paginacao.last_page"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'page-link'"
            :next-class="'page-link'"
            :prev-text="'<<'"
            :next-text="'>>'"
            :click-handler="paginar">
        </paginate>
      </div>
    </nav>

    <!-- Modal de Situação da Autorização -->
    <div class="modal fade" id="situacaoAutorizacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Autorização</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <template v-if="autorizacao">
                <div class="alert d-flex justify-content-between mb-3 px-2" :class="'alert-' + autorizacao.autorizacao.status_solicitacao.color">
                    <div>{{ autorizacao.nome_paciente }}</div>
                    <div>{{ autorizacao.autorizacao.status_solicitacao.msg }}</div>
                </div>

                <button type="button" class="btn btn-outline-primary mb-3" @click="editar_contatos(autorizacao)">
                    <i class="fa fa-comment mr-2" aria-hidden="true"></i>
                    Ocorrências
                </button>

                <table class="table">
                    <tr :class="'table-' + traduzir_status_autorizacao(autorizacao.autorizacao.in_status).color">
                        <td>{{ autorizacao.procedimento.search }}</td>
                        <td class="text-right">{{ traduzir_status_autorizacao(autorizacao.autorizacao.in_status).msg }}
                            <div v-if="autorizacao.autorizacao.st_codigo_autorizacao" class="small text-muted">
                                <div>Senha: {{ autorizacao.autorizacao.st_codigo_autorizacao }}</div>
                                <div v-if="autorizacao.autorizacao.dt_valid_termino">Valid.: {{ $util.getFormatDate(autorizacao.autorizacao.dt_valid_termino) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(outro, iox) in autorizacao.autorizacao.js_secundarios" :key="iox"
                        :class="'table-' + traduzir_status_autorizacao(outro.in_status).color">
                        <td>{{ outro.search }}</td>
                        <td class="text-right">
                            {{ traduzir_status_autorizacao(outro.in_status).msg }}
                            <div v-if="outro.st_codigo_autorizacao" class="small text-muted">
                                <div>Senha: {{ outro.st_codigo_autorizacao }}</div>
                                <div v-if="outro.dt_valid_termino">Valid.: {{ $util.getFormatDate(outro.dt_valid_termino) }}</div>
                            </div>
                        </td>
                    </tr>
                </table>

                <div v-if="autorizacao.autorizacao && autorizacao.autorizacao.contatos && autorizacao.autorizacao.contatos.length">
                    <table class="table table-hover table-sm">
                        <thead>
                            <tr>
                                <th>Ocorrência</th>
                                <th>Data</th>
                                <th>Usuário</th>
                                <th>Observação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(contato, ic) in autorizacao.autorizacao.contatos" :key="ic">
                                <td>
                                    <span v-if="contato.contato_status" :class="'badge badge-' + contato.contato_status.st_color">
                                        {{ contato.contato_status.search }}
                                    </span>
                                </td>
                                <td>{{ $util.getFormatDate(contato.created_at) }} {{ contato.created_at.slice(11,16) }}</td>
                                <td>
                                    <span v-if="contato.usuario">
                                        {{ contato.usuario.st_login }}
                                    </span>
                                </td>
                                <td>{{ contato.st_observacoes }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Obs Bloqueio -->
    <div class="modal fade" id="modalObsBloqueio" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="obs_bloqueio">
          <div class="modal-header">
            <h5 class="modal-title">Observação do Bloqueio</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info">
              {{ obs_bloqueio.hora }}
            </div>

            <az-input
              placeholder="Observação..."
              type="textarea" 
              rows="3"
              v-model="obs_bloqueio.bloqueio.st_observacao" />

            <pre v-if="false">{{ obs_bloqueio }}</pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="atualizar_obs_bloqueio()">Atualizar</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Documentos -->
    <documento ref="documento" :recepcao="true" refresh="imprimir_documento" />

    <!-- Cadastrar Paciente -->
    <div class="modal fade" id="novoPacienteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="dados_novo_paciente">
                <div class="modal-header">
                    <h5 class="modal-title">Incluir Paciente</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mb-2" v-if="dados_novo_paciente.paciente && !dados_novo_paciente.id_pessoa && !dados_novo_paciente.paciente.verificado">
                        <cadastro-paciente-primeira-vez 
                            ref="cadPaciente1" 
                            v-model="dados_novo_paciente.paciente"
                            @selecionado="primeiraVezSelecionado" />
                    </div>
                    <div class="mb-2" v-else>
                        <cadastro-paciente
                            :marcacao="marcacao"
                            v-model="dados_novo_paciente.paciente"
                            formName="cadpac"
                            :editar="true"
                            :noButtons="true"
                            ref="cadPaciente"
                            :validate="validate"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    <az-submit v-if="dados_novo_paciente.paciente.verificado" @click="salvar_paciente()">{{ dados_novo_paciente.paciente.id_pessoa ? 'Atualizar' : 'Incluir' }}</az-submit>
                </div>
            </div>
        </div>
    </div>

    <trocar-medico-comp ref="trocar_medico_comp" :lista_medicos="lista_medicos" @refresh="load(false)" />
    <marcar-bloco ref="marcarbloco" @refresh="load(false)" />
    <confirmacao-alterar-extra ref="conf_extra" @refresh="load(false)" />
    <selecao-medico-lista ref="selmed" @selecionados="filtrar_selecao_medicos" />
    <log-integracao ref="logint" />
    <medico-obs ref="medico_obs" @refresh="load(false)" />
    <relatorio-agendas-com-horarios ref="relatorio_agendas" />

    <importacao v-if="false" service="marcacoes" @refresh="load(false)" :chunk_size="10" />

    <!-- Filtros -->
    <crm-filtros ref="filtros" model_type="App\azure\marcacao" @refresh="atualizar_filtros"/>

    <!-- Registrar Contatos -->
    <registrar-contatos 
        :lista_status="lista_status_aut ? lista_status_aut.filter(item => item.id_contato_status != 'R') : []" 
        ref="regcontatos" 
        @refresh="load()">
        <template v-slot:info>
            <div class="alert alert-secondary" v-if="edicao_contatos">
                <span v-if="edicao_contatos.paciente" class="lead">
                    {{ edicao_contatos.paciente.st_nome }}
                </span>
                <span v-else-if="edicao_contatos.cadastro_temporario" class="lead">
                    {{ edicao_contatos.cadastro_temporario.st_nome }}
                </span>

                <div>
                    #{{ edicao_contatos.id_solicitacao_autorizacao }}
                    <span class="badge badge-light ml-3" v-if="edicao_contatos.unidade_operacao && edicao_contatos.unidade_operacao.st_sigla">
                        {{ edicao_contatos.unidade_operacao.st_sigla }}
                    </span>
                </div>
                <div v-if="edicao_contatos.dt_solicitacao">
                    {{ $util.getFormatDate(edicao_contatos.dt_solicitacao) }}
                </div>
                <div v-if="edicao_contatos.plano" class="small">
                    {{ edicao_contatos.plano.search }}
                </div>

                <hr>

                <div v-if="edicao_contatos.procedimento">
                    {{ edicao_contatos.procedimento.search }}
                </div>
                <div v-if="edicao_contatos.medico" class="small">
                    {{ edicao_contatos.medico.search }}
                </div>
            </div>
        </template>
    </registrar-contatos>

    <br><br><br><br><br><br><br>
  </div>
</template>

<script>
// import draggable from "vuedraggable";

import _ from "lodash";
import * as moment from "moment";
import $ from "jquery";
import SubMenuCallCenter from "./SubMenuCallCenter.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import CancelarMarcacao from "./CancelarMarcacao.vue";
import AzFileUpload from '../../util/AzFileUpload.vue';

import CelulaHorariosMarcacao from "../../shared/table/CelulaHorariosMarcacao.vue";
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import CelulaDadosContatos from "../../shared/table/CelulaDadosContatos.vue";
import Marcacao from './Marcacao.vue';
import ProcedimentosSolicitados from './ProcedimentosSolicitados.vue';
import AzInstrucoes from '../../util/AzInstrucoes.vue';

import ConfirmacaoBotoes from './ConfirmacaoBotoes.vue';
import AgendaDoMedico from './AgendaDoMedico.vue';

import TabelaAgendas from './TabelaAgendas.vue';
import Avatar from 'vue-avatar'

import Documento from '../consultorio/Documento.vue';

import CadastroPacientePrimeiraVez from '../recepcao/CadastroPacientePrimeiraVez.vue';
import CadastroPaciente from "../../shared/CadastroPaciente.vue";

import SelecaoRecursos from '../../shared/SelecaoRecursos.vue';

import MapaDeSala from './MapaDeSala.vue';
import TrocarMedicoComp from './TrocarMedicoComp.vue';
import MarcarBloco from './MarcarBloco.vue';
import ConfirmacaoAlterarExtra from './ConfirmacaoAlterarExtra.vue';
import SelecaoMedicoLista from './SelecaoMedicoLista.vue';

import HistoricoPacotesPaciente from '../../shared/HistoricoPacotesPaciente.vue';
import RelatoriosLinkados from '../../relatorios/shared/RelatoriosLinkados.vue';

import LogIntegracao from '../../shared/audit/LogIntegracao.vue';
import PrintExport from '../../shared/PrintExport.vue';

import Importacao from '../../cadastros/shared/Importacao.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';

import MedicoObs from './MedicoObs.vue';
import MedicoObsLista from './MedicoObsLista.vue';

import RelatorioAgendasComHorarios from './RelatorioAgendasComHorarios.vue';

import CrmFiltros from '../crm/CrmFiltros.vue';

export default {
  data() {
    return {
      lista: null,
      status: "A",
      medico: "",
      medicos: [],
      search: "",
      marcacoes: null,
      marcacoes_recursos: null, 
      search_timeout: null,
      confirm_obs: "",
      confirm_tipo: "",
      confirm_marcacao: null,
      show_print: true,
      filtro_id_local: "", 
      feriado: null,
      bloqueio: null,
      refData: null, 
      refHora: null,
      refHg: null, 
      refUnidOper: "", 
      flag_agendar: false, 
      drag_to_idx: null, 
      drag_origem: null, 
      acao_anexar: false, 
      marcacao: null, 
      enviar_confirmacao: false, 
      enviada_confirmacao: false, 
      instrucoes: null, 
      especialidade: "",
      canceltoken: null, 
      status_confirmacao: "", 
      paginacao: null, 
      page: 1, 
      texto_add: "", 
      hor_livre_todos: false, 
      agenda_do_medico: null, 
      autorizacao: null, 
      pode_bloquear_horario: false,
      pode_marcar_bloco: false, 
      marcar_id_unidade_operacao: null, 
      proced_descr_paciente: false, 
      turno: "G",
      paciente: "", 
      obs_bloqueio: null, 
      tem_tk: false, 
      dados_novo_paciente: null,
      dados: { 
        plano: "", 
        procedimento: "", 
        procedimento_equipamentos: null, 
      },
      recursos: null, 
      show_mapa: false, 
      info_md: null,
      componentKey: 0,
      pode_alterar_extra: false, 
      filtro_lista_medicos: [], 
      show_medico_agenda_recursos: true, 
      show_apenas_livres: false, 
      filas_proc: null, 
      id_fila_laudo: "", 
      block_medico_fixo: false,
      abrindo: true, 
      viewonly: false, 
      grupoProf: "A",
      confirm_trocar_medico: false, 
      confirm_medico_residente: false, 
      is_kualiz: false,
      lista_status_aut: null, 
      edicao_contatos: null, 
      medico_obs: null, 
      lista_add_filtros: [], 
    };
  },

  computed: {
    is_teste: function () { 
        return window.redir && ( window.redir.includes('teste') ) ? true : false;
    },

    lista_ids: function () { 
        if ( !this.lista ) 
            return [];

        return _.uniq(
            this.lista.filter(hor => hor && hor.marcacao && hor.marcacao.id_marcacao)
                .map(hor => hor.marcacao.id_marcacao)
                .sort()
        );  
    },

    lista_locais: function () { 
        if ( !this.lista ) 
            return [];

        return _.orderBy(
            _.uniqBy(
                this.lista.filter(hor => hor && hor.marcacao && hor.marcacao.local)
                    .map(hor => hor.marcacao.local),
                'id_local'
            ), 
            'st_local'
        );  
    },

    reintegracao_labs: function () { 
      return ( window.redir == 'labs' || window.redir == 'teste' ) 
        && this.$store.state.user.id_usuario == 1;
    },

    cc: function () { 
      return this.$route.path.substr(0,17) == '/centro-cirurgico'
        || this.$route.path.substr(0,8) == '/infusao';
    },

    infusao: function () { 
      return this.$route.path.substr(0,8) == '/infusao';
    },

    lista_unidades: function () { 
      // this.$store.state.unidade.unidade_operacaos
      return _.orderBy(
        this.$util.unidades_com_tags(false, true).filter(item => !item.fl_unidade_adm),
        'st_nome'
      );
    },

    lista_status: function () { 
      if ( !this.medico && ( this.hor_livre_todos || this.filtro_lista_medicos.length ) ) { // this.referencia == this.referencia_fim && 
        return [{id: 'A', search: 'Ativos'}, {id: 'B', search: 'Bloqueados'}, {id: 'C', search: 'Cancelados'}, {id: 'H', search: 'Horários'}];
      } else if ( this.referencia != this.referencia_fim && this.medico ) { 
        return [{id: 'Z', search: 'Todos'}, {id: 'A', search: 'Ativos'}, {id: 'B', search: 'Bloqueados'}, {id: 'C', search: 'Cancelados'}, {id: 'H', search: 'Horários'}];
      } else if ( this.referencia != this.referencia_fim || !this.medico ) { 
        return [{id: 'Z', search: 'Todos'}, {id: 'A', search: 'Ativos'}, {id: 'B', search: 'Bloqueados'}, {id: 'C', search: 'Cancelados'}];
      } else { 
        return [{id: 'A', search: 'Ativos'}, {id: 'B', search: 'Bloqueados'}, {id: 'C', search: 'Cancelados'}, {id: 'H', search: 'Horários'}];
      }
    },
    ref_marcar: function () { 
      return this.refData ? this.refData : this.referencia;
    },
    referencia: {
      get() {
        return this.$store.state.referencia;
      },
      set(value) {
        this.$store.commit("setReferencia", value);
      }
    },
    referencia_fim: {
      get() {
        return this.$store.state.referencia_fim;
      },
      set(value) {
        this.$store.commit("setReferenciaFim", value);
      }
    },
    lista_por_turno: function () { 
      return this.lista.filter(item => 
            ( this.turno == 'G'
                || ( this.turno == 'M' && item.hora < '13:00') 
                || ( this.turno == 'V' && item.hora >= '13:00' && item.hora < '19:00') 
                || ( this.turno == 'N' && item.hora >= '19:00') 
            )
            && ( !this.lista_locais || !this.lista_locais.length || !this.filtro_id_local || ( item.marcacao && item.marcacao.local && item.marcacao.local.id_local == this.filtro_id_local ) )
        );
    },

    exibicao: function() {
      //let self = this;
      let items = this.lista;

      if (!items || !items.length) return null;

      if ( this.filtro_id_local ) { 
        items = items.filter(item => item.marcacao && item.marcacao.local && item.marcacao.local.id_local == this.filtro_id_local);
      }

      if ( this.grupoProf == 'G' ) { 
        items = _.orderBy(items, item => {
          return item.medico ? item.medico.search : 'Sem Médico';
        });
      }

      items = _.groupBy(items, item => {

        if ( this.grupoProf == 'G' ) { 
            return item.medico ? item.medico.search : 'Sem Médico';
        }

        return ( this.status == 'H' || 1 == 1 ) 
          ? ( item.titulo ? item.titulo : 'Horários' ) 
          : item.marcacao.status_confirmacao;

      });
      
      let ordered = {};   

      _(items).keys().sort().each(function (key) {
        ordered[key] = items[key];
      });

      console.log('ordered', ordered);

      return ordered;
    },
    exibicaoStatus() {
      let descricao =
        this.status == "A"
          ? "Ativos"
          : this.status == "B"
          ? "Bloqueados"
          : "Cancelados";

      return descricao;
    },

    lista_medicos: function () { 
      if ( !this.especialidade || !this.medicos )
        return this.medicos;

      return this.medicos.filter(
        item => item.medico_especialidade.findIndex(
          esp => esp.id_especialidade == this.especialidade.id_especialidade
        ) >= 0
      );
    },

    outras_ordenadas: { 
      get () { 
        if ( !this.confirm_marcacao || !this.confirm_marcacao.outras_marc ) { 
          return [];
        }

        return _.orderBy(this.confirm_marcacao.outras_marc, 'dt_inicio');
      },
      set (dado) { 
        console.log(dado);
      }
    }

  },

  components: {
    SubMenuCallCenter,
    AzEmptyState,
    CancelarMarcacao,
    AzInput,
    AzSubmit,
    CelulaHorariosMarcacao,
    CelulaDadosPaciente,
    CelulaDadosProcedimento,
    CelulaDadosContatos,
    Marcacao,
    AzFileUpload,
    ProcedimentosSolicitados,
    AzInstrucoes,
    ConfirmacaoBotoes,
    TabelaAgendas,
    Avatar,
    AgendaDoMedico,
    Documento, 
    CadastroPacientePrimeiraVez, 
    CadastroPaciente, 
    SelecaoRecursos, 
    MapaDeSala, 
    // draggable, 
    TrocarMedicoComp,
    MarcarBloco,
    ConfirmacaoAlterarExtra, 
    SelecaoMedicoLista, 
    HistoricoPacotesPaciente, 
    RelatoriosLinkados,
    LogIntegracao, 
    PrintExport, 
    Importacao, 
    RegistrarContatos, 
    MedicoObs, 
    MedicoObsLista, 
    RelatorioAgendasComHorarios, 
    CrmFiltros, 
  },

  props: ["pInicio", "pTermino", "pMedico", "pStatus", "pIdBloq", "block_menu", "id_medico_fixo"],

  methods: {
    incluir_filtro () { 
        this.$refs.filtros.abrir(0); 
    },

    atualizar_filtros () { 
        this.lista_add_filtros = ( this.$refs.filtros ? this.$refs.filtros.get_filtros(0) : [] ); 
    },

    toggle_exibir_tabela () { 
        this.$util.setCookie('cs-show-tab', this.show_medico_agenda_recursos ? 'N' : '');
    },

    primeiraVezSelecionado() { 
        this.validate = false;
    },

    abrir_obs (id_medico, dt_data) { 
        this.$refs.medico_obs.abrir(id_medico, dt_data);
    },

    remover_reserva (hor) { 
        $('[data-toggle="tooltip"]').tooltip('dispose');

        if ( !confirm ('Confirma remover a reserva?') ) 
            return; 

        this.$util.remover (this, { 
            service: 'reserva_horarios',
            dados: { 
                id_reserva_horario: hor.reserva.id_reserva_horario,
            },
            reload: true, 
        });
        
    },
    editar_contatos(solic) { 
        $('.modal').modal('hide');

        if ( this.lista_status_aut === null ) { 
            this.$util.loadItem(this, { 
                service: 'contato_status',
                func: 'index',
                parms: { 
                    lista: true,
                    model: 'solicitacaoAutorizacao',
                    ativos: true, 
                }
            })
            .then(res => { 
                this.lista_status_aut = res;
            });
        }

        this.$util.load(this, { 
            service: 'solicitacao_autorizacoes',
            func: 'show',
            parms: { 
                id: solic.id_solicitacao_autorizacao, 
                contatos: true, 
            },
            loadTo: res => { 
                this.edicao_contatos = _.cloneDeep(res);
                this.edicao_contatos.model = { 
                    type: 'solicitacaoAutorizacao',
                    id: solic.id_solicitacao_autorizacao,
                };
                
                this.$refs.regcontatos.editar(this.edicao_contatos);
            }
        });
        
    },

    solicitar_estoque(marcacao = null) { 
        $('.modal').modal('hide');
        this.$root.solicitar_estoque('S', { marcacao: marcacao }); 
    },

    qtd_status (lista, status, slots = false) { 
        if ( !lista || !lista.length )
            return 0;

        if ( status == 'livre' ) { 
            return lista.filter(item => item && ( item.status == status ))
                .reduce((total, carry) => { 
                    return total + ( ( carry.ordem_chegada && carry.vagas ) ? carry.vagas : 1 );
                }, 0);    
        }

        if ( status == 'ocupado' && slots ) { 
            return lista.filter(item => item && ( item.status == status ))
                .reduce((total, carry) => { 
                    return total + ( ( carry.marcacao && carry.marcacao.in_slots ) ? carry.marcacao.in_slots : 1 );
                }, 0);    
        }

        return lista.filter(item => item && ( item.status == status )).length;
    },

    abrir_log_int(marcacao) { 
        this.$refs.logint.abrir('marcacao', marcacao.id_marcacao, true);
    },

    abrir_pagamentos(marcacao) {
      if ( !marcacao )
        return;

      if ( !marcacao.id_paciente ) { 
        this.$router.push({ path: '/call-center/pagamentos/' + ( marcacao.id_cadastro_temporario ? 'p' + marcacao.id_cadastro_temporario : '' ) });
      } else { 
        this.$router.push({ path: '/call-center/pagamentos/' + ( marcacao.id_paciente ? marcacao.id_paciente : '' ) });
      }
    },

    filtrar_selecao_medicos (lista_selec) { 
      let lista = lista_selec.map(item => item.id_pessoa);

      if ( lista.length == 1 ) { 
        this.filtro_lista_medicos = [];
        this.medico = lista[0];  
      } else { 
        if ( !lista.length && this.status == 'H' && !this.hor_livre_todos ) { 
          this.status = 'A';
          this.lista = [];
        }

        this.filtro_lista_medicos = lista;
      }

      this.$util.setCookie('rlm', JSON.stringify(this.filtro_lista_medicos));

      this.load();
    },

    selecionar_medicos () { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      this.$refs.selmed.abrir(this.lista_medicos, this.filtro_lista_medicos);
    },

    alterar_extra (marcacao) { 
      this.$refs.conf_extra.abrir(marcacao);
    },

    marcar_bloco (lista) { 
        this.$refs.marcarbloco.abrir(lista);
    },

    trocar_medico_comp (lista, compartilhada = true, auxiliar = false) { 
      this.$refs.trocar_medico_comp.abrir(lista, this.medico, compartilhada, auxiliar);
    },

    tem_medico_comp (lista) { 
      if ( !lista )
        return false;

      return lista.findIndex(item => item.medico.fl_agenda_compartilhada 
        && item.marcacao 
        && item.marcacao.id_medico_comp
        && item.marcacao.ch_estado_marcacao == 'A' 
        && !item.marcacao.id_atendimento ) >= 0;
    },

    scroll_to_table () { 
      if ( this.$refs.tabagd ) { 
        const posic = this.$refs.tabagd.getBoundingClientRect().top + window.scrollY - 100;
        console.log(posic);
        window.scrollTo({ top: posic, behavior: 'smooth' });
      } else { 
        console.log('nao achou');
      }
    },

    selecionar_medico_dia (info) { 
      this.load(true, null, info);
    },

    fechar_modal (modal) { 
      $('#' + modal).modal('hide');
    },

    selecionarProcedimento (procedimento) { 

      if ( procedimento ) {

        if ( this.recursos === null ) { 

          this.loadOptions ('marcacoes.stats', 'marcacoesStats', { para_marcacao: true })
            .then(res => {
              this.recursos = res.recursos;
            });

        }

        this.$util.loadItem(this, { 
          service: 'marcacoes',
          func: 'stats', 
          parms: { 
            id_plano: this.dados.plano ? this.dados.plano.id_plano : null,
            id_procedimento: procedimento.id_procedimento,
            adicao_direta: false,
            id_unidade_operacao: this.refUnidOper, 
            cc: this.cc ? true : false, 
            infusao: this.infusao ? true : false, 
            recursos: true, 
          },
        })
        .then(res => { 
          this.dados.procedimento_equipamentos = res.recursos;
        });

      }

    },

    salvar_paciente () {

      if (this.dados_novo_paciente.paciente.cadastro.endereco.cidade) {
        this.dados_novo_paciente.paciente.cadastro.endereco.id_cidade = this.dados_novo_paciente.paciente.cadastro.endereco.cidade.id_cidade;
      } else {
        this.dados_novo_paciente.paciente.cadastro.endereco.id_cidade = null;
      }

      this.$util.atualizar(this, { 
        service: 'pacientes', 
        func: 'store',
        dados: { 
          paciente: this.dados_novo_paciente.paciente,
          marcacao: this.dados_novo_paciente,
          agenda: true, 
          novo_cadastro: true 
        },
        modal: 'novoPacienteModal',
        reload: true, 
      });

    },
    cadastrar_paciente (marcacao) { 
      if ( marcacao.id_paciente ) { 
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Paciente já cadastrado.",
          life: 5000
        });
        return;
      }

      this.dados_novo_paciente = null;

      this.$nextTick(() => { 
        this.validate = false;
        let dados = _.cloneDeep(marcacao);

        dados.paciente = { 
            id_pessoa: null,
            verificado: false, 
            st_nome: dados.cadastro_temporario.st_nome, 
            cpf_nao_obrigatorio: false, 
            cadastro: { 
                ch_sexo: dados.cadastro_temporario.ch_sexo,
                dt_nascimento: dados.cadastro_temporario.dt_nascimento, 
                fl_estrangeiro: false, 
                st_cpf: dados.cadastro_temporario.st_cpf, 
                st_nome_mae: dados.cadastro_temporario.st_nome_mae,
                st_rg: dados.cadastro_temporario.st_rg, 
                st_email: dados.cadastro_temporario.st_email, 
                telefones: { 
                    telefone: dados.cadastro_temporario.st_telefone,
                    celular: dados.cadastro_temporario.st_celular, 
                },
                endereco: { 
                    cidade: null, 
                }, 
            },
            paciente_unidade: { 
                st_numero_carteira: dados.cadastro_temporario.st_numero_carteira, 
                dt_validade_carteira: dados.cadastro_temporario.dt_validade_carteira,
                st_numero_prontuario: "", 
                plano: dados.plano, 
            },
        };

        this.dados_novo_paciente = dados;

        $('#novoPacienteModal').modal('show');
      });
    },

    novoDocumento(marcacao) {
      this.$refs.documento.novoDocumento(marcacao);
    },

    editar_marcacao (hor) { 
        if ( this.viewonly ) { 
            this.$toast.add({
                severity: "warn",
                summary: "Atenção",
                detail: "A edição não está disponível.",
                life: 5000
            });
            return;
        }

        if ( hor && hor.marcacao ) { 
            this.$root.editar_marcacao(
                hor.marcacao.id_marcacao, 
                () => { 
                    this.load(false);
                }, 
                { 
                    cancelar: marcacao => { 
                      this.cancelarAtendimento(marcacao);
                    },
                    remarcar: marcacao => { 
                        this.remarcar(marcacao);
                    },
                    confirmar: (marcacao, tipo) => { 
                        this.confirmar(marcacao, tipo);
                    }
                },
            );
        }
    },

    abrir_atendimento(id_atendimento) { 
      this.$util.abrir_atendimento(this, id_atendimento);
    },

    integrar_klingo_pacientes () { 

      if ( !this.lista ) { 
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Selecione os pacientes.",
          life: 5000
        });
        return;
      }

      let lista = this.lista.filter(item => item.marcacao && item.marcacao.ch_estado_marcacao ==  'A' && item.marcacao.tem_tk);
      // && item.marcacao.unidade_operacao && item.marcacao.unidade_operacao.tem_tk

      if ( !lista.length ) { 
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Nenhum paciente disponível para integração.",
          life: 5000
        });
        return;
      }

      if ( !confirm('Confirma integrar os pacientes listados?') ) { 
        return;
      }

      this.$util.atualizar(this, { 
        service: 'terceiros',
        func: 'integrar_klingo',
        dados: { 
          lista: lista.map(item => item.marcacao.id_marcacao),
          confirm: true,
        },
      });

    },

    reintegrar_pacientes () { 
      if ( !this.lista ) { 
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Selecione os pacientes.",
          life: 5000
        });
        return;
      }

      let lista = this.lista.filter(item => item.marcacao && item.marcacao.ch_estado_marcacao ==  'A');

      if ( !lista.length ) { 
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Nenhum paciente disponível para reintegrar.",
          life: 5000
        });
        return;
      }

      if ( !confirm('Confirma reintegrar os pacientes listados?') ) { 
        return;
      }

      this.$util.atualizar(this, { 
        service: 'terceiros',
        func: 'reintegrar_labs',
        dados: { 
          lista: lista.map(item => item.marcacao.id_marcacao)
        },
      });
    },

    atualizar_obs_bloqueio () { 
      this.$util.atualizar(this, { 
        service: 'bloqueios',
        func: 'store',
        dados: { 
          ...this.obs_bloqueio.bloqueio,
          mais_30_dias: this.obs_bloqueio.bloqueio.dt_termino, 
        },
        modal: 'modalObsBloqueio',
        toast: true, 
        reload: true, 
      });
    },

    set_obs_bloqueio (hor) { 
      this.obs_bloqueio = _.cloneDeep(hor);

      $('#modalObsBloqueio').modal('show');
    },

    set_nome_search(search) {
      if ( this.search == search )
        this.search = "";
      else
        this.search = search;

      this.pesquisar();
    },

    bloquear_horario(hor) { 

        if ( this.viewonly ) { 
            this.$toast.add({
                severity: "warn",
                summary: "Bloquear Horário",
                detail: "A edição não está disponível.",
                life: 5000
            });
            return;
        }

        let bloq_filtros = [];

        if ( hor.coleta_dom && hor.id_local ) { 
            bloq_filtros.push({
            model_type: 'App\\azure\\local',
            model_id: hor.id_local,
            fl_regra: true, 
            excluido: false, 
            model: { 
                id_local: hor.id_local, 
            }
            });
        }

        this.$util.atualizar(this, { 
            service: 'bloqueios',
            func: 'horario', 
            dados: { 
            id_medico: hor.id_medico,
            id_agenda: hor.id_agenda,
            dt_inicio: hor.data + ' ' + hor.hora,
            filtros: bloq_filtros
            },
            continue_loading: true, 
            callback: () => { 
            this.load(false);
            }
        });
    },

    traduzir_status_autorizacao(status) { 
        switch (status) {
            case 0: return { msg: 'Aberto', color: 'primary' };
            case 1: return { msg: 'Autorizado', color: 'success' };
            case 2: return { msg: 'Em análise', color: 'info' };
            case 3: return { msg: 'Negado', color: 'danger' };
            case 4: return { msg: 'Autorizado Parcialmente', color: 'warning' };
            case 5: return { msg: 'Cancelado', color: 'Secondary' };
            case 6: return { msg: 'Enviado', color: 'dark' };
            case 7: return { msg: 'Negado Parcialmente', color: 'danger' };
            case 8: return { msg: 'Cancelado Parcialmente', color: 'secondary' };
            default: return { msg: status, color: 'light' };
        }
    },

    ver_autorizacao (marcacao) { 
        this.autorizacao = null; 
        $('#situacaoAutorizacaoModal').modal('show');

        this.$util.load(this, { 
            service: 'solicitacao_autorizacoes',
            func: 'show',
            parms: { 
                id: marcacao.id_solicitacao_autorizacao,
                para_agendar: true, 
                contatos: true, 
            },
            loadTo: res => { 
                this.autorizacao = _.cloneDeep(marcacao);
                this.autorizacao.autorizacao = res;
            },
        });

      //this.autorizacao = _.cloneDeep(marcacao);
      
    },

    ativar_rebuscar (ref = null) { 
      this.lista = null;
      this.agenda_do_medico = null;
      this.page = 1;

      if (ref == "I") {
        this.referencia_fim = this.referencia;

        if ( this.referencia == this.$util.hoje() ) { 
          this.load();
        }
      } else {
        if (this.referencia_fim < this.referencia)
          this.referencia = this.referencia_fim;
      }
    },

    paginar (page) {
      this.page = page;
      this.load(false);
    },
    
    adcionar_marcacao(marcacao) {
      $('[data-toggle="tooltip"]').tooltip("dispose");

      if ( this.cc ) { 
        this.$router.push({
            name: "centro-cirurgico",
            params: { aba: 'marcacao', adicao: marcacao.id_marcacao },
        });  
      } else { 
        this.$router.push({
            name: "call-center",
            params: { adicao: marcacao.id_marcacao },
        });
      }
    },
    
    novoAtendimento(item) {
      this.marcar_id_unidade_operacao = this.refUnidOper;

      if ( this.$store.state.unidade.unidade_operacaos.length == 1 ) { 

        this.unidade_operacao = this.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao;
        this.marcar_id_unidade_operacao = this.unidade_operacao;

      } else if ( !this.refUnidOper && this.$store.state.unidade.unidade_operacaos.length > 1 ) { 

        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Selecione a unidade.",
          life: 5000
        });

        return;
      
      }

      this.flag_agendar = true;

      this.$nextTick(() => { 
        this.$refs.marcacao.reiniciar({ extra: ( item ? false : true ) });
        this.refData = item ? item.data : "";
        this.refHora = item ? item.hora : "";
        this.refHg = item ? item.hg : "";
        this.marcar_id_unidade_operacao = item ? item.id_unidade_operacao : this.marcar_id_unidade_operacao;
        $("#novoAtendimentoConfirmacaoModal").modal("show");

        if ( this.medico ) { 

          this.$util.loadItem(this, { 
            service: 'medicos',
            id: this.medico 
          })
          .then(res => { 
            this.$nextTick (() => { 
              this.$refs.marcacao.selecionarMedico(res);
            });
          });

        }
      });

    },

    enviar_lista_confirmacao(lista) { 

      $('[data-toggle="tooltip"]').tooltip("dispose");

      if ( !confirm ('Confirma enviar mensagens de confirmação?') )
        return;

      $('[data-toggle="tooltip"]').tooltip("dispose");
      this.enviada_confirmacao = true;

      this.$util.atualizar(this, { 
        service: 'agendas',
        func: 'enviar_confirmacao',
        dados: { 
          lista: lista.map(item => item.marcacao),
        },
        callback: res => { 

          if ( res.status_code == 200 ) { 

            if ( process.env.VUE_APP_GTAG && res.qtd > 0 ) { 

              let action = 'msg-confirmacao-agenda';
              let label = this.$store.state.user.id_usuario;

              this.$gtag.event(action, {
                  'event_category': window.redir,
                  'event_label': label,
                  'value': res.qtd
              });

            }

            this.$toast.add({
              severity: "success",
              summary: "Envio de Mensagens",
              detail: res.msg,
              life: 3000
            });

          }

        }
      })

    },

    ordem_hor(items) { 
      return _.orderBy(items, item => item.data + ' ' + item.hora);
    },
    abrir_anexar_arquivo(marcacao) { 
      console.log('anexar', marcacao);

      this.marcacao = marcacao;
      this.acao_anexar = true;

      // Ajuste para carregar os arquivos sempre que clicar no botão
      this.carregar_arquivos(true);
      return;

      /*
      if ( this.marcacao.arquivos && this.marcacao.arquivos.length && !this.marcacao.arquivos.find(arq => arq.arquivo) ) { 

        this.carregar_arquivos(true);

        return;
      }
      
      this.$nextTick(() => { 
        this.$refs.upload.abrir();
      });
      */
    },

    carregar_arquivos (abrir = false) {

      this.$store.commit('loading', true);

      if ( this.marcacao.id_marcacao ) { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_marcacao,
            type: 'marcacao',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });

      } else if ( this.marcacao.id_cadastro_temporario ) { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_cadastro_temporario,
            type: 'cadastroTemporario',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });

      } else { 

        this.$util.loadItem(this, {
          service: 'arquivos',
          func: 'links',
          parms: {
            id: this.marcacao.id_pessoa,
            type: 'pessoa',
          }
        })
        .then(res => {
          this.marcacao.arquivos = res;

          if ( abrir ) {
            this.$nextTick(() => {
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });


      }

    },

    /*
    carregar_arquivos (abrir = false) { 

      this.$store.commit('loading', true);

      this.$util.loadItem(this, { 
        service: 'arquivos',
        func: 'links',
        parms: { 
          id: this.marcacao.id_marcacao, 
          type: 'marcacao',
        }
      })
      .then(res => { 
        this.marcacao.arquivos = res;

        if ( abrir ) { 
          this.$nextTick(() => { 
            this.$refs.upload.abrir();
          });
        }
      })
      .finally(() => { 
        this.$store.commit('loading', false);
      });

    },
    */

    // Drag and Drop 
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('item', 1)
      this.drag_origem = item;
      console.log('start', item);
    },

    onDrop(evt, destino) {
      if ( destino && !destino.marcacao ) { 

        this.drag_to_idx = null;
        destino.status = "enviando...";
        
        this.$util.atualizar(this, { 
          service: 'marcacoes',
          func: 'mudar_horario',
          dados: { 
            id: this.drag_origem.marcacao.id_marcacao,
            novo_horario: destino.hora,
          },
          callback: () => { 
            this.load(false);
          }
        });

      }
    },
    //
    verMarcar (hor, proc = null) {  
        if ( this.viewonly ) { 
            this.$toast.add({
                severity: "warn",
                summary: "Atenção",
                detail: "A edição não está disponível.",
                life: 5000
            });
            return;
        }
        
        if ( proc && proc.bloqueado ) { 
            alert('Procedimento ' + proc.st_procedimento + ': BLOQUEADO!');
            return;
        }

        if( hor && hor.id_unidade_operacao ) { 

            this.marcar_id_unidade_operacao = hor.id_unidade_operacao;

        } else { 

            this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Unidade não identificada.",
            life: 5000
            });

            return;

        }

        let dados = {};

        if ( hor.id_local && hor.paralela ) { 
            dados.id_local = hor.id_local;
        }

        dados.id_agenda = hor.id_agenda;
        dados.extra = hor.extra ? true : false; 
        dados.ordem_chegada = hor.ordem_chegada ? true : false; 
        dados.reservar = hor.reservar ? true : false;

        if ( hor.coleta_dom ) { 
            dados.coleta_dom = hor.coleta_dom;
        }

        this.flag_agendar = true;

        this.$nextTick (() => { 

            this.$util.loadItem(this, { 
            service: 'medicos',
            id: this.medico 
                ? this.medico 
                : ( ( hor.medico && hor.medico.id_pessoa ) ? hor.medico.id_pessoa : this.$store.state.user.id_pessoa ),
            })
            .then(res => { 
            this.refData = hor.data;
            this.refHora = hor.hora;
            this.refHg = hor.hg;
            this.$refs.marcacao.reiniciar(dados); 

            $("#novoAtendimentoConfirmacaoModal").modal("show");

            this.$nextTick (() => { 
                if ( proc ) { 
                this.$refs.marcacao.selecionarProcedimento(proc);
                }

                this.$refs.marcacao.selecionarMedico(res);
            });
            
            });

        });

    },
    confirmar_telegram(marcacao) { 
      $('[data-toggle="tooltip"]').tooltip("dispose");
      marcacao.enviando = true;
      this.$forceUpdate();

      this.$util.atualizar(this, { 
        service: 'telegram',
        func: 'confirmar_agendamento',
        dados: { 
          id_marcacao: marcacao.id_marcacao, 
        },
        callback: () => { 
          this.$toast.add({
            severity: "success",
            summary: "Telegram",
            detail: "Mensagem enviada com sucesso!",
            life: 3000
          });
        },
        final: () => { 
          marcacao.enviando = false;
          this.$forceUpdate();
        },
      });
    },
    agrupar(lista, campo = null) {
      let items = lista;

      if (!items || !items.length) return null;

      if ( this.especialidade && this.status != 'H' ) { 
        items = items.filter(item => item.marcacao.procedimento.id_especialidade == this.especialidade.id_especialidade);
      }

      if (!items || !items.length) return null;

      let ordered = _.orderBy(items, item => {
          return ( ( this.grupoProf == 'G' && item.medico ) ? item.medico.search : '' ) + '-' +  
            item.data + '-' + item.hri + '-' + ( item.titulo ? item.titulo : ' ' ) + '-' + item.hora;
        });

      items = _.groupBy(ordered, 
          item => {
            if (campo == "data") { 
                return item.data;
            } else { 
                if ( this.grupoProf == 'G' || campo == 'medico' ) {
                    if ( item.medico && item.medico.st_nome_exibicao ) { 
                        return item.medico.st_nome_exibicao; 
                    }

                    return item.medico ? item.medico.search : 'Sem Médico';
                }

                return ( this.status == 'H' || ( this.paginacao && this.status_confirmacao != 3 ) ) 
                    ? ( item.titulo ? item.titulo : 'Horários' )
                    : ( item.marcacao ? item.marcacao.status_confirmacao : '-' );
            }
          }
        );

      return items;

      /*
      let ordered = {};   
      _(items).keys().sort().each(function (key) {
        ordered[key] = items[key];
      });
      */

      //return ordered;
    },
    sem_resposta_count(marcacao, status = 1) {
      if (!marcacao || !marcacao.historico_status_marcacaos) return 0;

      return marcacao.historico_status_marcacaos.filter(item => {
        return item.id_status_marcacao == status;
      }).length;
    },
    desenv() {
      alert("Em desenvolvimento...");
    },
    remarcar(marcacao) {
        $('[data-toggle="tooltip"]').tooltip("dispose");

        if ( this.viewonly ) { 
            this.$toast.add({
                severity: "warn",
                summary: "Atenção",
                detail: "A edição não está disponível.",
                life: 5000
            });
            return;
        }

        if ( 1==1 || marcacao.tem_outras || marcacao.outros_proc ) { 
            this.$util.remarcar(marcacao, { infusao: this.infusao, cc: this.cc && !this.infusao });
            return;
        }

        this.$router.push({
            name: "call-center",
            params: { remarcacao: marcacao.id_marcacao }
        });
    },

    getHora(valor) {
        if (valor) return valor.substr(11, 5);
    },
    pesquisar() {
      this.$store.commit("loading", true);

      if (this.search_timeout) clearTimeout(this.search_timeout);

      this.search_timeout = setTimeout(() => {
        if ( this.referencia != this.referencia_fim || 1 == 1 ) // this.paginacao
          this.load(true, 'P');
        else
          this.filtrar();

        this.search_timeout = null;
      }, 300);
    },
    filtrar() {
      let pesquisar = this.search.trim();
      let parts = pesquisar.replace(" ", ".*");
      let match = parts;
      let reg = new RegExp(match, "i");
      let items;

      if (pesquisar && this.marcacoes && this.search != '#autoagendamento' ) {
        items = this.marcacoes.filter(item => {
          return reg.test(JSON.stringify(item));
        });
      } else {
        items = this.marcacoes;
      }

      this.lista = _.cloneDeep(items);

      this.$store.commit("loading", false);
    },

    trocar_data(data) { 
        this.referencia = data;
        this.load(false, 'I');
    },

    load(showSpinner = true, ref = null, info_md = null) {
    
        if ( this.abrindo ) { 
            console.log('abrindo...');
            return;
        }

        this.info_md = info_md;

      if (ref == "I") {
        this.referencia_fim = this.referencia;
        this.page = 1;
      } else if ( ref ) {
        this.page = 1;
      } else {
        if (this.referencia_fim < this.referencia)
          this.referencia = this.referencia_fim;
      }

      if ( ( this.referencia != this.referencia_fim ) && this.status == 'H' && ( !this.medico ) ) { // || this.hor_livre_todos ) ) { 
        // this.status = 'A';
        this.show_mapa = true;
      } else { 
        this.show_mapa = false;
      }

      if ( this.status == 'H' && this.paciente ) { 
        this.status = 'A';
        return;
      } else if ( this.status == 'H' && !this.medico && !this.hor_livre_todos && ref == 'M' && !this.id_medico_fixo ) { 
        this.status = 'A';
      }

      if (showSpinner) {
        this.lista = [];
        this.marcacoes = null;
        this.paginacao = null;
        this.$forceUpdate();
      }

      this.enviada_confirmacao = false;

      this.$util.setCookie('unidade-confirmacao', this.refUnidOper, 365);

      if ( this.show_mapa && !info_md ) { 
        this.$nextTick(() => { 
          this.$refs.mapa.filtros.tipo = 'M';
          this.$refs.mapa.filtros.periodo = "";
          this.$refs.mapa.filtros.inicio = this.referencia;
          this.$refs.mapa.filtros.fim = this.referencia_fim;
          this.$refs.mapa.filtros.especialidade = this.especialidade;
          this.$refs.mapa.filtros.unidade_operacao = this.refUnidOper;

          this.$refs.mapa.load();
        });

        return;
      }

      this.$store.commit("loading", true);
      
      let query = {
        q: [
          {
            name: "agendas.index",
            id: "lista",
            parms: {
              data: info_md ? info_md.data : this.referencia == this.referencia_fim ? this.referencia : null, 
              inicio: this.referencia,
              fim: info_md ? info_md.data + " " + "23:59:59" : this.referencia_fim + " " + "23:59:59",
              medico: info_md ? info_md.id_medico : this.medico,
              medicos: ( this.filtro_lista_medicos && this.filtro_lista_medicos.length ) ? this.filtro_lista_medicos : null , 
              group: "none",
              livres: ( info_md || ( this.status == 'H' && ( this.referencia == this.referencia_fim || this.medico ) ) ) ? true : false, // this.medico &&
              telefones: ( this.status == 'H' && this.referencia == this.referencia_fim && !this.medico) ? false : true,
              status: this.status == 'H' ? 'A' : this.status,
              confirmacao: true,
              search: this.search.trim(),
              unidade_operacao: this.pIdBloq ? null : this.refUnidOper, 
              status_confirmacao: this.status_confirmacao, 
              page: this.page,
              id_bloqueio: this.pIdBloq, 
              id_especialidade: this.especialidade ? this.especialidade.id_especialidade : null, 
              paciente: ( this.paciente && this.paciente.id_pessoa < 0 )  
                ? this.paciente.id_cadastro_temporario * -1
                : ( this.paciente ? this.paciente.id_pessoa : null ), 
              turno: this.turno, 
              cc: this.cc, 
              infusao: this.infusao, 
              procedimento: ( this.dados.procedimento ? this.dados.procedimento.id_procedimento : "" ),
              plano: ( this.dados.plano ? this.dados.plano.id_plano : "" ),
              recursos: ( this.dados.procedimento_equipamentos ) 
                  ? this.dados.procedimento_equipamentos.filter(item => !item.excluido) 
                  : null, 
              id_fila_laudo: this.id_fila_laudo, 
              block_medico_fixo: this.block_medico_fixo,
              add_filtros: this.status == 'H' ? null : this.lista_add_filtros, 
            }
          },
          { 
            name: "mensagens_tipo.show",
            id: "mensagem",
            parms: { 
              id: 4
            }
          },
          {
            name: 'configuracoes.index',
            id: 'configmotivo',
            parms: {
              where: {
                st_slug: 'motivo-bloqueio-horario',
                fl_ativo: '1',
              }
            } 
          },
          {
            name: 'configuracoes.index',
            id: 'configmarcarbloco',
            parms: {
              where: {
                st_slug: 'confirm-marcar-bloco',
                fl_ativo: '1',
              }
            } 
          },
          {
            name: 'configuracoes.servico_whatsapp',
            id: 'configwhatsapp',
          },
        ]
      };

      if (!this.medicos.length) {
        query.q.push({ name: "medicos.index", id: "medicos", parms: { ativos: true } });
      } 
      
      if ( this.medico ) { 
        query.q.push({ name: "instrucoes.show", id: "instrucoes", parms: { id_medico: this.medico } });

        if ( this.referencia == this.referencia_fim ) { 
          query.q.push({ 
            name: "medicos.agenda_semanal", 
            id: "hormedico", 
            parms: { 
              id_medico: this.medico, 
              data: this.referencia,
              id_unidade_operacao: this.refUnidOper, 
            } 
          });
        }
      } else { 
        this.agenda_do_medico = null;
      }

      this.instrucoes = null;
      //this.agenda_do_medico = null;

      if ( this.canceltoken ) {
          this.canceltoken.cancel('#BC#');
      }

      this.canceltoken = this.axios.CancelToken.source();

      this.axios
        .post("/aql?a=agendas.index.conf&page=" + this.page, query, {
            cancelToken: this.canceltoken.token
        })
        .then(res => {
          if ( !res.data )
            return;

          this.medico_obs = res.data.lista.data.medico_obs;

          this.marcacoes = res.data.lista.data.agendas;
          this.marcacoes_recursos = res.data.lista.data.agenda_recursos;
          this.feriado = res.data.lista.data.feriado;
          this.bloqueio = res.data.lista.data.bloqueio;
          this.paginacao = res.data.lista.data.paginate;

          this.tem_tk = ( this.marcacoes.find(mrc => mrc.marcacao && ( mrc.marcacao.tem_tk || ( this.refUnidOper && mrc.marcacao.unidade_operacao && mrc.marcacao.unidade_operacao.tem_tk ) ) ) ) ? true : false;

          this.filtrar();
          if (!this.medicos.length) this.medicos = res.data.medicos.data;

          if ( res.data.mensagem.status == 200 ) { 
            this.enviar_confirmacao = res.data.mensagem.data.fl_ativo;
          }

          if ( res.data.instrucoes && res.data.instrucoes.status == 200 ) { 
            this.instrucoes = res.data.instrucoes.data;
          }

          if ( res.data.hormedico && res.data.hormedico.status == 200 ) { 
            this.agenda_do_medico = res.data.hormedico.data;
          } else { 
            this.agenda_do_medico = null;
          }

          if ( res.data.configmotivo && res.data.configmotivo.status == 200 ) { 
            this.pode_bloquear_horario = ( _.get(res.data.configmotivo.data, '0.st_valor') > 0 );
          }

          if ( res.data.configmarcarbloco && res.data.configmarcarbloco.status == 200 ) { 
            this.pode_marcar_bloco = ( _.get(res.data.configmarcarbloco.data, '0.st_valor') > 0 );
          }

          //   console.log('configwhatsapp', res.data);

          if (res.data.configwhatsapp && res.data.configwhatsapp.status == 200) {
            this.is_kualiz = (res.data.configwhatsapp && res.data.configwhatsapp.data && res.data.configwhatsapp.data.servico == 'QualizapHelper')
            // Todo: Desativado pq o kualiz está dando erro no openChat - Esperando o pessoal resolver
            this.is_kualiz = false;
          }

          if ( this.info_md ) { 
            this.$nextTick(() => { 
              this.scroll_to_table();
            });
          }

          if ( this.block_medico_fixo ) { 

            if ( res.data.lista.data.acessos ) { 
                if ( res.data.lista.data.acessos.voa === true ) { 
                  this.block_medico_fixo = false;
                }

                if ( res.data.lista.data.acessos.apc === false ) { 
                  this.viewonly = true;
                }
            }

          }

        })
        .finally(() => {
          this.$store.commit("loading", false);
          this.firstLoad = true;
        });
    },
    cancelarAtendimento(marcacao) {
      this.$refs.canc_atd.cancelar(marcacao);
    },
    confirmar(marcacao, tipo) {
      if ( !marcacao.outras_marc ) { 
        marcacao.outras_marc = null;
      }

      if ( this.confirm_marcacao )
        this.$refs.instruc_conf.reset();

      this.confirm_tipo = tipo;
      this.confirm_obs = "";

      this.$nextTick(() => { 
        if ( marcacao ) { 
          $("#confirmacaoModal").modal("show");
        } else { 
          console.log('Falha na abertura do modal de confirmação.');
        }
      });

      let parms;

      if ( marcacao.id_paciente ) { 
        parms = { 
          id_paciente: marcacao.id_paciente,
        };
      } else { 
        parms = { 
          id_cadastro_temporario: marcacao.id_cadastro_temporario,
        };
      }

      if ( !marcacao.outras_marc ) { 

        this.$util.loadItem(this, {
          service: 'marcacoes',
          func: 'index',
          parms: { 
            ...parms,
            show_outros: true, 
            data: marcacao.dt_inicio.substr(0, 10),
            confirm_marcacao: true 
          },
        })
        .then(res => { 
          marcacao.outras_marc = this.adicionar_selecao(res)
          this.componentKey++
          this.$forceUpdate();

          this.confirm_marcacao = marcacao;

          this.$nextTick(() => { 
            this.$refs.instruc_conf.buscar_plano(marcacao);
            this.$refs.instruc_conf.buscar_procedimento(marcacao.outras_marc);
          });
        });

      } else { 

        this.confirm_marcacao = marcacao;
        this.confirm_marcacao.outras_marc = this.adicionar_selecao(marcacao.outras_marc);
        this.componentKey++
        
        this.$nextTick(() => { 
          this.$refs.instruc_conf.buscar_plano(marcacao);
          this.$refs.instruc_conf.buscar_procedimento(marcacao.outras_marc);
        });

      }

    },

    marcacao_unica() {

      const array_marcacao = this.confirm_marcacao.outras_marc;  
      
      if(array_marcacao && array_marcacao.length < 2) 
        return true;

      return false;
    },

    adicionar_selecao(lista_outras) {
      
      return lista_outras.map(procedimento => {        
        
        procedimento.selected = true; 
        return procedimento
      });

    },

    confirmar_salvar() {
      this.$store.commit("loading", true);
      
      const outras = this.confirm_marcacao.outras_marc ?
          (this.marcacao_unica() ? this.confirm_marcacao.outras_marc : this.confirm_marcacao.outras_marc.filter(outra => _.get(outra,'selected'))) : [];

      console.log(outras)
      if(outras.length < 1) {
        
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Selecione ao menos um procedimento",
          life: 5000
        });

        this.load(false);
        $("#confirmacaoModal").modal("hide");
        this.$store.commit("loading", true);

        return;
      }

      let query = {
        q: [
          {
            name: "marcacoes.confirmar",
            id: "confirmar",
            parms: {
              id: this.confirm_marcacao.id_marcacao,
              status: this.confirm_tipo,
              obs: this.confirm_obs,
              outras: outras.map(item => item.id_marcacao),
              status_marcacao: this.confirm_marcacao.ch_estado_marcacao, 
            }
          }
        ]
      };

      this.axios
        .post("/aql?a=marcacoes.confirmar", query)
        .then(res => {
          if (res.data.confirmar.status == 200) {
            this.load(false);
            $("#confirmacaoModal").modal("hide");
          }
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    },

    kualiz_open_chat(marcacao) {
        this.tooltip_hide();
        console.log('kualiz_open_chat', marcacao);

        this.$util.atualizar(this, {
              service: 'agendas',
              func: 'kualiz_open_chat',
              dados: {
                  id_marcacao: marcacao.id_marcacao
              },
              toast: true,
        });
    },

    whatsapp_link(marcacao) {
      let nl = "%0D%0A";
      let msg = "Prezado(a) ";
      let celular = "";
      let exterior = false;

      if (marcacao.paciente) {
        msg = msg + marcacao.paciente.st_nome;
        celular = marcacao.paciente.cadastro.telefones.celular;
        exterior = ( marcacao.paciente.cadastro.telefones.pc == '+' );
      } else {
        msg = msg + marcacao.cadastro_temporario.st_nome;
        celular = marcacao.cadastro_temporario.st_celular;
        exterior = ( marcacao.cadastro_temporario.st_cod_pais == '+' );
      }

      if (!celular) {
        return "javascript:alert('Celular não disponível')";
      }

      if ( !exterior ) {       
        celular = "55" + celular;
      }

      msg = msg + nl;

      msg = msg + ( marcacao.ch_estado_marcacao == 'B' ? "Agenda Bloqueada:" : "Confirmação de marcação:" ) + nl;

      if ( this.proced_descr_paciente ) { 
        msg = msg + "> " + ( marcacao.procedimento.st_nome_completo ? marcacao.procedimento.st_nome_completo : marcacao.procedimento.search ) + nl;
      } else { 
        msg = msg + "> " + marcacao.procedimento.search + nl;
      }

      if ( marcacao.medico.in_numero_conselho && marcacao.medico.in_numero_conselho <= 99 ) { 
        //
      } else { 
        msg = msg + "> Dr(a) " + marcacao.medico.search + nl;
      }
      
      msg = msg + "> " + moment(marcacao.dt_inicio).format("DD/MM/YYYY");
      msg = msg + " às " + moment(marcacao.dt_inicio).format("HH:mm") + ( marcacao.fl_ordem_chegada ? ' (Ordem de Chegada)' : '' ) + nl;

      if ( marcacao.unidade_operacao && marcacao.unidade_operacao.st_nome ) { 
        msg = msg + "> " + marcacao.unidade_operacao.st_nome + nl;
      }

      if ( this.texto_add ) { 
        msg = msg + this.texto_add.replace('\n', nl);
      }

      return "https://wa.me/" + celular + "?text=" + msg;
    },

    tooltip_hide() {
      console.log("Hide Tooltip");
      $('[data-toggle="tooltip"]').tooltip("dispose");
    },

    imprimirAgendas (idia) { 
        this.tooltip_hide(); 

        let lista = this.agrupar(
            _.get(this.agrupar (this.lista_por_turno, 'data'), idia),
            'medico'
        );

        console.log('idia', idia);
        console.log('lista', lista);
        
        this.$refs.relatorio_agendas.imprimir(lista);
    },

    imprimirLista(id) {
      this.show_print = false;
      console.log("antes", this.show_print);
      this.$nextTick(() => {
        this.$htmlToPaper(id, null, () => {
          console.log("Printing");
        });

        this.show_print = true;
        console.log("dd", this.show_print);
      });
    }
  },

  created() {

    if ( this.$route.params && this.$route.params.marcacao ) { 

      this.referencia = this.$route.params.marcacao.dt_inicio.substr(0,10);
      this.referencia_fim = this.$route.params.marcacao.dt_inicio.substr(0,10);
      this.medico = "";
      this.refUnidOper = this.$route.params.marcacao.id_unidade_operacao;
      this.search = this.$route.params.marcacao.nome_paciente;

    } else { 

      if (this.pInicio) this.referencia = this.pInicio.substr(0, 10);

      if (this.pMedico) this.medico = this.pMedico;

      if (this.pStatus) this.status = this.pStatus;

      this.refUnidOper = this.$util.getCookie('unidade-confirmacao') ? this.$util.getCookie('unidade-confirmacao') : '';

    }

  },

  beforeMount() { 

    this.show_medico_agenda_recursos = this.$util.getCookie('cs-show-tab') == 'N' ? false : true;

    if ( this.id_medico_fixo ) { 

        this.block_medico_fixo = true;
    
        let lista = this.$util.getCookie('rlm');

        if ( lista && lista != '[]' ) { 
            lista = JSON.parse(lista);

            if ( lista ) { 
            this.filtro_lista_medicos = lista;
            }
        }

    }

    if ( !this.$store.state.options['fila_laudo.index.confirm.proced.todas'] ) { 

      this.$util.loadItem(this, { 
        service: 'fila_laudos', 
        func: 'index', 
        parms: { 
          todas: true, 
        },
        configs: [
          'confirm-fila-laudo', 
          'confirm-marcacao-trocar-profissional-bloco', 
          'confirm-medico-residente', 
        ]
      })
      .then(res => { 

        if ( this.$store.state.contexto['confirm-fila-laudo'] ) { 
          this.filas_proc = res.filter(fila => ( fila.fl_fila_procedimento || fila.fl_fila_enfermagem ) && fila.fl_ativo); 
        } else { 
          this.filas_proc = [];
        }

        if ( this.$store.state.contexto['confirm-marcacao-trocar-profissional-bloco'] ) {
            this.confirm_trocar_medico = true; 
        }

        this.$store.commit('setOptions', { 
          name: 'fila_laudo.index.confirm.proced.todas',
          list: this.filas_proc
        });

      });

    } else { 

      this.filas_proc = this.$store.state.options['fila_laudo.index.confirm.proced.todas'];

    }

  },

  mounted() {

    if ( this.block_menu ) { 
      //
    } else if ( this.infusao ) { 
      this.$store.commit("setBreadcrumb", [
        { name: "Infusão", path: "/infusao/planejamento" },
        { name: "Confirmação", path: "/infusao/confirmacao" }
      ]);
    } else if ( this.cc ) { 
      this.$store.commit("setBreadcrumb", [
        { name: "Centro Cirúrgico", path: "/centro-cirurgico/marcacao" },
        { name: "Confirmação", path: "/centro-cirurgico/confirmacao" }
      ]);
    } else if ( this.pIdBloq ) {
        this.$store.commit("setBreadcrumb", [
            { name: "Call Center", path: "/call-center" },
            { name: "Bloqueio", path: "/call-center/bloqueio" },
            { name: "Confirmação", path: "/call-center/confirmacao" }
        ]);
    } else {    
      this.$store.commit("setBreadcrumb", [
        { name: "Call Center", path: "/call-center" },
        { name: "Confirmação", path: "/call-center/confirmacao" }
      ]);
    }

    let config = this.$store.state.options['config-confirm'];

    if ( !config ) { 

      this.$util.loadItem(this, { 
        service: 'configuracoes',
        func: 'index',
        parms: { 
          where: { 
            st_slug: ['texto-confirm-whatsapp', 'confirm-livre-todos', 'proced-descr-paciente', 'confirm-altera-extra', 'confirm-medico-residente'],
          }
        }
      })
      .then(res => { 
        
        let options = { name: 'config-confirm', list: res };
        this.$store.commit('setOptions', options);

        this.texto_add = _.get(res.find(item => item.st_slug == 'texto-confirm-whatsapp'), 'st_valor');
        this.hor_livre_todos = _.get(res.find(item => item.st_slug == 'confirm-livre-todos'), 'st_valor') == 1;
        this.proced_descr_paciente = ( _.get(res.find(item => item.st_slug == 'proced-descr-paciente'), 'st_valor') == 1 );
        this.pode_alterar_extra = ( _.get(res.find(item => item.st_slug == 'confirm-altera-extra'), 'st_valor') == 1 );
        this.confirm_medico_residente = ( _.get(res.find(item => item.st_slug == 'confirm-medico-residente'), 'st_valor') == 1 );
                
      });

    } else { 

      this.texto_add = _.get(config.find(item => item.st_slug == 'texto-confirm-whatsapp'), 'st_valor');
      this.hor_livre_todos = _.get(config.find(item => item.st_slug == 'confirm-livre-todos'), 'st_valor') == 1;
      this.proced_descr_paciente = ( _.get(config.find(item => item.st_slug == 'proced-descr-paciente'), 'st_valor') == 1 );
      this.pode_alterar_extra = ( _.get(config.find(item => item.st_slug == 'confirm-altera-extra'), 'st_valor') == 1 );
      this.confirm_medico_residente = ( _.get(config.find(item => item.st_slug == 'confirm-medico-residente'), 'st_valor') == 1 );
      
    }

    if ( this.id_medico_fixo ) { 

      this.referencia = this.$util.hoje();
      this.referencia_fim = moment().add(4, "days").format('YYYY-MM-DD');     

      this.medico = this.id_medico_fixo;

      this.$nextTick(() => { 
        this.status = 'H';
      });

    } else { 

      if ( this.pIdBloq ) { 
        this.referencia = this.pInicio.substr(0, 10);
        this.referencia_fim = this.pTermino.substr(0, 10);
      }

    }

    this.$nextTick(() => { 
        this.abrindo = false; 

        if ( !this.id_medico_fixo && ( !this.medicos || !this.medicos.length ) ) { 
            this.load();
        }
    });

  },

  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>

.painel { 
  position: absolute;
  overflow: auto;
  width: 300px;
  z-index: 1010;  
  padding: 0px;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.drag-to { 
  background-color: #b8daff;
}

</style>
